<template>
  <div>
    <!-- Questions table -->
    <div class="card questions mt-3"
         qid="questions-section"
         id="update_question"
    >

      <div class="card-body" style="overflow-x:auto;">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="questions-table-title">
                {{ $t('maintenance.questions.label') }}
              </h5>
              <span v-if="getGuide('assessment_template_questions')">
                <GuideButton :guide="getGuide('assessment_template_questions')"></GuideButton>
              </span>
            </div>

          </div>
          <div class="col-sm-6 text-right">

            <button class="btn btn-success ml-3 pl-3 pr-3"
                    @click="showCreateQForm()"
                    qid="question-create-button"
                    v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create_button') }}
            </button>
          </div>
        </div>

        <br>
        <!-- Control objectives -->
        <draggable v-model="tableItems"
                   v-if="assessment.type == 'control'"
                   class="dragArea"
                   @start="drag=true"
                   @end="drag=false"
                   @change="postOrder"
                   :options="{group: 'object', handle:'.dnd-drag-me'}">

          <div v-for="(object, index) in tableItems"
               :key="index"
               class="dnd-row dnd-category mt-3"
               :class="!object.name ? 'alert-danger' : null"
          >
            <span style="cursor: move;" class="text-center dnd-drag-me">
              <font-awesome-icon icon="grip-vertical" />
            </span>

            <span style="width: calc(100% - 170px); display: inline-block;">
              <strong>{{ object.name }}</strong>
            </span>

            <span v-if="object && object.name" class="text-right">
              <span class="btn btn-edit"
                    qid="edit-q-modal"
                    v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                    @click="showEditCOModal(object)"
              >
                <font-awesome-icon icon="pen"/>
              </span>
              <button class="btn btn-delete"
                      qid="delete-question-modal"
                      v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                      @click="showConfirmDeleteCOModal(object)"
              >
                <font-awesome-icon icon="trash-alt" />
              </button>
            </span>

            <!-- Assessment questions -->
            <draggable v-model="object.questionItems"
                       :id="'category-' + index"
                       class="dragArea"
                       :force-fallback="true"
                       @start="drag=true"
                       @end="drag=false"
                       @change="postOrderQuestions($event, object)"
                       :options="{group: 'questionItems', handle:'.dnd-drag-me'}">

              <div v-for="(item, index) in object.questionItems"
                   :key="index"
                   class="dnd-row dnd-item"
                   :id="item.id"
              >
                <span style="cursor: move;" class="text-center dnd-drag-me">
                  <font-awesome-icon icon="grip-vertical" />
                </span>

                <span style="width: calc(100% - 150px); display: inline-block;">
                  <span v-if="item && item.name">
                    <span v-if="item.reference"><strong>{{ item.reference }}: </strong></span>{{ item.name }}
                  </span>
                </span>

                <span v-if="item && item.name" class="text-right">
                  <span class="btn btn-edit"
                        qid="edit-q-modal"
                        v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                        @click="showEditQModal(item)"
                  >
                    <font-awesome-icon icon="pen"/>
                  </span>
                  <button class="btn btn-delete"
                          qid="delete-question-modal"
                          v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                          @click="showQConfirmDeleteModal(item)"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </button>
                </span>
              </div>
            </draggable>
          </div>
          <div class="dnd-row dnd-item text-center" v-if="!loading && !tableItems.length">
            <h5 class="mt-3">
              {{ $t('system.no_results') }}
            </h5>
          </div>
          <div class="mt-3 mb-3" v-if="loading">
            <div class="swing-container">
              <div class="swing">
                <div class="swing-l"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="swing-r"></div>
              </div>
            </div>
          </div>
        </draggable>


        <!-- Assessment questions -->
        <draggable v-model="tableRiskItems"
                   class="dragArea"
                   :force-fallback="true"
                   @start="drag=true"
                   @end="drag=false"
                   @change="postRiskOrder($event, object)"
                   :options="{group: 'questionItems', handle:'.dnd-drag-me'}">

          <div v-for="(item, index) in tableRiskItems"
               :key="index"
               class="dnd-row dnd-category mt-3"
               :id="item.id"
          >
                <span style="cursor: move;" class="text-center dnd-drag-me">
                  <font-awesome-icon icon="grip-vertical" />
                </span>

            <span style="width: calc(100% - 150px); display: inline-block;">
                  <span v-if="item && item.name">
                    <span v-if="item.reference"><strong>{{ item.reference }}: </strong></span>{{ item.name }}
                  </span>
                </span>

            <span v-if="item && item.name" class="text-right">
                  <span class="btn btn-edit"
                        qid="edit-q-modal"
                        v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                        @click="showEditQModal(item)"
                  >
                    <font-awesome-icon icon="pen"/>
                  </span>
                  <button class="btn btn-delete"
                          qid="delete-question-modal"
                          v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"
                          @click="showQConfirmDeleteModal(item)"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </button>
                </span>
          </div>
        </draggable>

        <!--<draggable-->
                <!--v-model="tableRiskItems"-->
                <!--:force-fallback="true"-->
                <!--@start="drag=true"-->
                <!--@end="drag=false"-->
                <!--tag="tbody"-->
                <!--@change="postRiskOrder"-->
                <!--:options="{group: 'object', handle:'.dnd-drag-me'}">-->
          <!--<tr v-for="object in tableRiskItems" :key="object.id">-->
            <!--<td style="cursor: move;" class="text-center" width="50">-->
              <!--<font-awesome-icon icon="arrows-alt" />-->
            <!--</td>-->
            <!--<td width="400">-->
                <!--<span v-if="object && object.name">-->
                  <!--{{ object.name }}-->
                <!--</span>-->
            <!--</td>-->
            <!--<td width="150">-->
                <!--<span v-if="object.response_type">-->
                  <!--<span class="badge badge-info">-->
                    <!--{{ $t('maintenance.questions.type.' + $options.filters.slugify(object.response_type)) }}-->
                  <!--</span>-->
                <!--</span>-->
            <!--</td>-->
            <!--<td width="200">-->
                <!--<span v-if="object.add_description">-->
                  <!--{{ $t('maintenance.questions.type.' + $options.filters.slugify(object.add_description)) }}-->
                <!--</span>-->
            <!--</td>-->
            <!--<td>-->
                <!--<span v-if="object.add_attachments">-->
                  <!--{{ $t('maintenance.questions.type.' + $options.filters.slugify(object.add_attachments)) }}-->
                <!--</span>-->
            <!--</td>-->
            <!--<td class="text-right">-->
                <!--<span class="btn btn-edit"-->
                      <!--qid="edit-v-modal"-->
                      <!--v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"-->
                      <!--@click="showEditRRModal(object)"-->
                <!--&gt;-->
                  <!--<font-awesome-icon icon="pen"/>-->
                <!--</span>-->
              <!--<button class="btn btn-delete"-->
                      <!--qid="delete-question-modal"-->
                      <!--v-if="isGranted([permissions.ASSESSMENT_EDIT, permissions.ASSESSMENT_EDIT_OWN], assessment.created_by) && (!getClient.parent || (getClient.parent && assessment.partition))"-->
                      <!--@click="showRRConfirmDeleteModal(object)"-->
              <!--&gt;-->
                <!--<font-awesome-icon icon="trash-alt" />-->
              <!--</button>-->
            <!--</td>-->
          <!--</tr>-->
          <!--<tr v-if="!loading && !tableRiskItems.length" qid="no-results-row-rr" class="text-center">-->
            <!--<td colspan="10">-->
              <!--<h5 class="mt-3">-->
                <!--{{ $t('system.no_results') }}-->
              <!--</h5>-->
            <!--</td>-->
          <!--</tr>-->
        <!--</draggable>-->
        <br>

      </div>
    </div>


    <!-- Delete Assessment Control modal template -->
    <b-modal ref="delete-question" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideQConfirmDeleteModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="delete-q-title">
            {{ $t('maintenance.questions.delete.title') }}
          </h5>
        </div>
      </template>
      <div class="mb-2 mt-3" style="font-size:18px;">
        <div>
          {{ $t('maintenance.risk_categories.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.risk_categories.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideQConfirmDeleteModal"
                            qid="delete-question-cancel-button"
                  >
                    {{ $t('maintenance.questions.delete.cancel') }}
                  </b-button>
                  <b-button @click="confirmDeleteQ(itemToDelete)"
                            class="ml-3"
                            variant="danger"
                            qid="delete-question-submit-button"
                  >
                    {{ $t('maintenance.questions.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Add new Assessment Control -->
    <b-modal ref="add-question-1"
             @hide="hideCreateQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

        <div class="form-container">
          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.question_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.question_description') }}
            </span>
          </div>

          <b-form-group>
            <label qid="create-q-name-label">
              {{ $t('maintenance.questions.create.name_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-input
              qid="create-q-form-name"
              type="text"
              v-model="form.name"
              required
              :maxLength="255"
              :placeholder="$t('maintenance.questions.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-reference-label">
              {{ $t('maintenance.questions.create.reference_label') }}
            </label>
            <b-form-input
              qid="create-q-form-reference"
              type="text"
              v-model="form.reference"
              :maxLength="255"
              v-on:input="debounceInput"
              :class="{'is-invalid': referenceInvalid}"
              :placeholder="$t('maintenance.questions.create.reference_placeholder')"
            ></b-form-input>
            <b-form-invalid-feedback
                v-if="referenceInvalid"
                qid="pasword-requirement-notice"
                class="d-block"
            >
              {{ $t('maintenance.questions.create.reference_error') }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group v-if="assessment.type !== 'risk'">
            <label qid="create-assessment-control-objective-label">
              {{ $t('maintenance.control_objective.title') }}<span class="mandatory"> *</span>
            </label>
            <div class="multiselect-row">
              <multiselect
                  v-model="selectedControlObjective"
                  :options="controlObjectives"
                  :placeholder="$t('maintenance.control_objective.title_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  required
                  :allow-empty="false"
                  @search-change="loadCO"
                  track-by="id"
                  qid="create-assessment-control-form-control-objective"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="book"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="book"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
              </multiselect>
              <b-button
                  class="btn btn-secondary float-right"
                  @click="showCreateControlObjectiveModal()"
                  qid="control-objective-create-button-fc-modal"
                  v-if="isGranted(permissions.CONTROL_OBJECTIVE_CREATE) && (!getClient.parent || (getClient.parent && object.partition))"
                  v-b-tooltip.hover
                  :title="$t('maintenance.control_objective.add_new')"
              >
                <font-awesome-icon icon="plus-circle"/>
              </b-button>
            </div>
            <p v-if="form.control_objective && form.control_objective.name">
              <font-awesome-icon icon="book"/>
              {{ form.control_objective.name }}
            </p>
          </b-form-group>
        </div>
        <div class="proxy-footer">
          <div class="progress-indicator-footer col text-center pt-2 pb-1">
            <ul class="progress-indicator pr-5 pl-5 mb-1">
              <li class="progress-active">1</li>
              <li class="progress-uncompleted">2</li>
              <li class="progress-uncompleted">3</li>
              <li class="progress-uncompleted">4</li>
              <li class="progress-uncompleted">5</li>
            </ul>

            <ul class="progress-indicator-text pr-4 pl-4">
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.linked_controls') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
            </ul>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreateQModal"
                            qid="create-q-cancel-button"
                  >
                    {{ $t('maintenance.questions.create.cancel') }}
                  </b-button>
                  <b-button @click="showCreateQForm2('forward')"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-q-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.questions.create.next') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </b-modal>

    <b-modal ref="add-question-2"
             @hide="hideEditQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.linked_controls_title') }}
          </h5>
          <span class="text-muted">
              {{ $t('maintenance.questions.create.linked_controls_description') }}
            </span>
        </div>

        <div class="">
          <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6 text-right">
              <button class="btn btn-success"
                      qid="frameworkControl-create-button"
                      @click="showAddLinkedControlModal"
              >
                <font-awesome-icon icon="plus"/> {{ $t('generic_controls.linked_controls.create_button') }}
              </button>
            </div>
          </div>
          <table class="table table-responsive-md table-list-secondary">
            <thead>
            <tr>
              <th scope="col">
                {{ $t('generic_controls.linked_controls.name') }}
              </th>
              <th width="100"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in selectedLinkedControls" :key="'table-row-' + index" :id="'table-row-' + index">
              <td scope="row">
                    <span v-if="item.assessment && item.assessment.name" class="text-muted">
                      {{ item.assessment.name }}
                    </span>
                    <br>
                    <span v-if="item && item.name">
                      <span v-if="item.reference">{{ item.reference }}:</span> {{ item.name }}
                    </span>
                <br>
              </td>
              <td>
                <button
                        class="btn btn-delete float-right"
                        qid="delete-framework_control-modal"
                        @click="removeLinkedControlItem(index)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </button>
              </td>
            </tr>
            <tr v-if="!selectedLinkedControls.length" qid="no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-completed">1</li>
            <li class="progress-active">2</li>
            <li class="progress-uncompleted">3</li>
            <li class="progress-uncompleted">4</li>
            <li class="progress-uncompleted">5</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class=""
                          variant="secondary"
                          @click="showCreateQForm1"
                          qid="create-q-cancel-button"
                >
                  {{ $t('maintenance.questions.create.back') }}
                </b-button>
                <b-button @click="showCreateQForm3('forward')"
                          class="ml-3"
                          variant="success"
                          :disabled="buttonDisabled"
                          qid="create-q-submit-button"
                >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal ref="add-question-3"
             @hide="hideCreateQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

        <div class="form-container">
          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.framework_controls_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.framework_controls_description') }}
            </span>
          </div>

          <div class="">
            <div class="row">
              <div class="col-sm-6">
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-success"
                        qid="frameworkControl-create-button"
                        @click="showAddFrameworkControlModal"
                >
                  <font-awesome-icon icon="plus"/> {{ $t('generic_controls.framework_controls.create_button') }}
                </button>
              </div>
            </div>
            <table class="table table-responsive-md table-list-secondary">
              <thead>
                <tr>
                  <th scope="col">
                    {{ $t('generic_controls.framework_controls.name') }}
                  </th>
                  <th width="100"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in selectedFrameworkControls" :key="'table-row-' + index" :id="'table-row-' + index">
                  <b-popover
                      :target="'table-row-' + index"
                      boundary="viewport"
                      triggers="hover"
                      placement="topleft"
                      :delay="{ show: 500, hide: 0 }"
                  >
                    <div v-if="item.active_framework && item.active_framework.name" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.questions.create.active_framework_name_label') }}:
                      </span>
                      <br>
                      {{ item.active_framework.name }}
                      <br>
                    </div>
                    <div v-if="item.control_objective && item.control_objective.name" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.questions.create.control_objective_name_label') }}:
                      </span>
                      <br>
                      {{ item.control_objective.name }}
                      <br>
                    </div>
                    <div v-if="item.control_objective && item.control_objective.description" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.questions.create.control_objective_description_label') }}:
                      </span>
                      <br>
                      {{ item.control_objective.description | truncate(200)}}
                      <br>
                    </div>
                    <div v-if="item && item.name" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.framework_control.table.name') }}:
                      </span>
                      <br>
                      {{ item.name }}
                      <br>
                    </div>
                    <div v-if="item.description" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.framework_control.create.description_label') }}:
                      </span>
                      <br>
                      {{ item.description | truncate(200)}}
                      <br>
                    </div>
                  </b-popover>
                  <td scope="row">
                    <span v-if="item.active_framework && item.active_framework.name" class="text-muted">
                      {{ item.active_framework.name }}
                    </span>
                    <br>
                    <span>
                      {{ item.full_name }}
                    </span>
                  </td>
                  <td>
                    <button
                        class="btn btn-delete float-right"
                        qid="delete-framework_control-modal"
                        @click="removeFrameworkControlItem(index)"
                    >
                      <font-awesome-icon icon="trash-alt"/>
                    </button>
                  </td>
                </tr>
                <tr v-if="!selectedFrameworkControls.length" qid="no-results-row" class="text-center">
                  <td colspan="10">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="proxy-footer">
          <div class="progress-indicator-footer col text-center pt-2 pb-1">
            <ul class="progress-indicator pr-5 pl-5 mb-1">
              <li class="progress-completed">1</li>
              <li class="progress-completed">2</li>
              <li class="progress-active">3</li>
              <li class="progress-uncompleted">4</li>
              <li class="progress-uncompleted">5</li>
            </ul>

            <ul class="progress-indicator-text pr-4 pl-4">
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
            </ul>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="showCreateQForm2('back')"
                            qid="create-q-cancel-button"
                  >
                    {{ $t('maintenance.questions.create.back') }}
                  </b-button>
                  <b-button @click="showCreateQForm4('forward')"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-q-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.questions.create.next') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </b-modal>

    <b-modal ref="add-question-4"
             @hide="hideCreateQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

        <div class="form-container">
          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.question_data_collection_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.question_data_collection_description') }}
            </span>
          </div>

          <div class="form-group">
            <label qid="create-q-data_collection-radio-label">
              {{ $t('maintenance.questions.create.data_collection_label') }}
            </label>
            <b-form-radio-group
                v-model="data_collection_on"
                :options="dataCollectionOptions"
                @change="lockSwitch(data_collection_on)"
                qid="create-q-data_collection-radio-option"
            ></b-form-radio-group>
          </div>
          <div v-if="data_collection_on">
            <b-form-group>
              <label qid="create-q-data_collection-description-label">
                {{ $t('maintenance.questions.create.data_collection_description_label') }}
                <span class="text-red">*</span>
              </label>
              <b-form-textarea
                      qid="create-q-data_collection-form-description"
                      v-model="form.data_collection_description"
                      rows="6"
                      max-rows="6"
                      required
                      :placeholder="$t('maintenance.questions.create.data_collection_description_placeholder')"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group>
              <div v-show="showDropActive" class="drop-active">
                <h3>Drop files to upload</h3>
              </div>

              <label> {{ $t('maintenance.questions.create.data_collection_attachment_label') }}</label>

              <div class="form-control auto-height pt-3 pb-3">
                <div class="text-center">
                  <p>
                    Drag and drop files in here or
                    <file-upload
                            ref="uploader"
                            v-model="data_collection_files"
                            :drop="true"
                            :multiple="true"
                            input-id="uploader"
                            name="uploader"
                            @input="onFileChangeDataCollectionEdit"
                            @dropActive="showDropActiveFunction"
                            class="text-success cursor-pointer"
                    >
                      click here
                    </file-upload>
                    to upload files you wish to display together with the description. You may also
                    <span class="text-success cursor-pointer" @click="showLinksSection = true">add links</span>
                  </p>
                </div>

                <p v-for="(file, media_index) in selectedQuestion.media" :key="media_index">
                <span v-if="file.collection_name == 'data_collection'">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteAttachmentModal(file)"
                        qid="remove-media-item"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer"
                        @click="downloadMedia(file)"
                        qid="download-media"
                  >
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
                </p>

                <div v-if="selectedQuestion.links">
                  <p v-for="(link, link_index) in getDataCollectionLinks" :key="link_index">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteLinkModal(link)"
                        qid="view-q-remove-link"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                    <a :href="link.url" target="_blank" qid="create-q-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </div>
            </b-form-group>

            <b-form-group v-if="showLinksSection">
              <label qid="create-q-link-label">
                {{ $t('maintenance.third_parties.create.links_label') }}
              </label>

              <div>
                <label class="mt-2">{{ $t('system.link') }}</label>
                <b-form-input
                        type="text"
                        aria-describedby="inputGroup"
                        v-model="inputLinkDataCollection"
                        :placeholder="$t('system.link')"
                        qid="create-q-links"
                ></b-form-input>
                <label class="mt-2">{{ $t('table.name') }}</label>
                <b-form-input
                        type="text"
                        aria-describedby="inputGroup"
                        v-model="inputLinkNameDataCollection"
                        :placeholder="inputLinkDataCollection ? inputLinkDataCollection : $t('table.name')"
                        qid="create-q-links"
                ></b-form-input>
                <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleEditDataCollectionLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
                </div>
              </div>
            </b-form-group>

            <b-form-group>
              <label qid="create-q-data_collection-description-label">
                {{ $t('maintenance.questions.create.data_collection_description_two_label') }}
                <span class="text-red">*</span>
              </label>
              <b-form-textarea
                      qid="create-q-data_collection-form-description"
                      v-model="form.data_collection_description_two"
                      rows="6"
                      max-rows="6"
                      required
                      :placeholder="$t('maintenance.questions.create.data_collection_description_two_placeholder')"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group>
              <div v-show="showDropActiveTwo" class="drop-active">
                <h3>Drop files to upload</h3>
              </div>

              <label> {{ $t('maintenance.questions.create.data_collection_two_attachment_label') }}</label>

              <div class="form-control auto-height pt-3 pb-3">
                <div class="text-center">
                  <p>
                    Drag and drop files in here or
                    <file-upload
                            ref="uploaderDataTwo"
                            v-model="data_collection_two_files"
                            :drop="true"
                            input-id="uploaderTwo"
                            name="uploaderTwo"
                            :multiple="true"
                            @input="onFileChangeDataCollectionTwoEdit"
                            @dropActive="showDropActiveFunctionTwo"
                            class="text-success cursor-pointer"
                    >
                      click here
                    </file-upload>
                    to upload files you wish to display together with the description. You may also
                    <span class="text-success cursor-pointer" @click="showLinksSectionTwo = true">add links</span>
                  </p>
                </div>

                <p v-for="(file, media_index) in selectedQuestion.media" :key="media_index">
                <span v-if="file.collection_name == 'data_collection_two'">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteAttachmentModal(file)"
                        qid="remove-media-item"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer"
                        @click="downloadMedia(file)"
                        qid="download-media"
                  >
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
                </p>

                <div v-if="selectedQuestion.links">
                  <p v-for="(link, link_index) in getDataCollectionTwoLinks" :key="link_index">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteLinkModal(link)"
                        qid="view-q-remove-link"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                    <a :href="link.url" target="_blank" qid="create-q-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </div>
            </b-form-group>


            <b-form-group v-if="showLinksSectionTwo">
              <label qid="create-q-link-label">
                {{ $t('maintenance.third_parties.create.links_label') }}
              </label>

              <div>
                <label class="mt-2">{{ $t('system.link') }}</label>
                <b-form-input
                        type="text"
                        aria-describedby="inputGroup"
                        v-model="inputLinkDataCollection"
                        :placeholder="$t('system.link')"
                        qid="create-q-links"
                ></b-form-input>
                <label class="mt-2">{{ $t('table.name') }}</label>
                <b-form-input
                        type="text"
                        aria-describedby="inputGroup"
                        v-model="inputLinkNameDataCollection"
                        :placeholder="inputLinkDataCollection ? inputLinkDataCollection : $t('table.name')"
                        qid="create-q-links"
                ></b-form-input>
                <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleEditDataCollectionTwoLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
                </div>
              </div>
            </b-form-group>



            <!--Documentation Response-->
            <b-form-group>
              <label qid="create-q-pg-label">
                {{ $t('maintenance.questions.create.add_response_label') }}
                <span class="text-red">*</span>
              </label>
              <multiselect
                      v-model="addResponseDoc"
                      :options="allowTypesDoc"
                      :placeholder="$t('maintenance.questions.create.add_response_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-q-form-pg"
              ></multiselect>
            </b-form-group>

            <b-form-group v-if="addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              <label qid="create-q-pg-label">
                {{ $t('maintenance.questions.create.type_label') }}
                <span class="text-red">*</span>
              </label>

              <multiselect
                      v-model="responseTypeDoc"
                      :options="responseTypes"
                      group-values="items"
                      group-label="group"
                      :group-select="false"
                      :placeholder="$t('maintenance.questions.create.type_placeholder')"
                      label="name"
                      @select="handleTypeDoc"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-q-form-pg"
              ></multiselect>
            </b-form-group>

            <b-form-group v-if="responseTypeDoc && responseTypeDoc.value === 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              <label qid="create-p-link-label">
                {{ $t('maintenance.questions.create.options_label') }}
                <span class="text-red">*</span>
              </label>
              <p v-for="(option, index) in selectedOptionsDoc"
                 :key="index"
                 class="mt-1 mb-1 pb-3 pt-3"
              >
              <span class="float-right btn btn-delete"
                    @click="removeOptionItemDoc(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
                <multiselect
                        v-model="option.value"
                        :options="answerTypes"
                        group-values="items"
                        group-label="group"
                        :group-select="false"
                        :placeholder="$t('maintenance.questions.create.type_placeholder')"
                        label="name"
                        :select-label="''"
                        :selected-label="''"
                        :deselect-label="''"
                        class="float-right mr-2"
                        style="width:220px;"
                        :allow-empty="false"
                        qid="create-p-form-pg"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                    <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                  </template>
                </multiselect>
                <span class="pt-2">{{ option.title }}</span>
              </p>
              <div class="input-group pt-2">
                <b-form-input
                        qid="create-p-form-link"
                        type="text"
                        v-if="showInputDoc"
                        v-on:keydown.enter="handleOptionDoc"
                        v-model="inputOptionDoc"
                        :placeholder="$t('maintenance.questions.create.options_placeholder')"
                ></b-form-input>
                <div class="input-group-append" v-if="showInputDoc">
                <span class="input-group-text cursor-pointer"
                      id="inputGroupDoc"
                      @click="handleOptionDoc"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
                </div>
              </div>
              <span class="btn btn-link cursor-pointer float-right"
                    @click="showInputDoc = true"
                    v-if="!showInputDoc"
                    qid="create-p-add-link"
              >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
            </b-form-group>

            <b-form-group v-if="responseTypeDoc && responseTypeDoc.value === 'Yes/No' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              <label qid="create-p-link-label">
                {{ $t('maintenance.questions.create.options_label') }}
                <span class="text-red">*</span>
              </label>
              <p class="mt-1 mb-1 pb-3 pt-3">
                <multiselect
                        v-model="yesValueDoc"
                        :options="answerTypes"
                        group-values="items"
                        group-label="group"
                        :group-select="false"
                        :placeholder="$t('maintenance.questions.create.type_placeholder')"
                        label="name"
                        :select-label="''"
                        :selected-label="''"
                        :deselect-label="''"
                        class="float-right mr-2"
                        style="width:220px;"
                        :allow-empty="false"
                        qid="create-p-form-pg"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                    <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                  </template>
                </multiselect>
                <span class="mt-2">Yes</span>
              </p>
              <p class="mt-1 mb-1 pb-3 pt-3">
                <multiselect
                        v-model="noValueDoc"
                        :options="answerTypes"
                        group-values="items"
                        group-label="group"
                        :group-select="false"
                        :placeholder="$t('maintenance.questions.create.type_placeholder')"
                        label="name"
                        :select-label="''"
                        :selected-label="''"
                        :deselect-label="''"
                        class="float-right mr-2"
                        style="width:220px;"
                        :allow-empty="false"
                        qid="create-p-form-pg"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                    <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                  </template>
                </multiselect>
                <span class="mt-2">No</span>
              </p>
            </b-form-group>

            <div class="text-muted mt-2 mb-3" v-if="responseTypeDoc && responseTypeDoc.value === 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              * {{ $t('maintenance.questions.create.helper_text_label') }}
            </div>
            <div class="text-muted mt-2 mb-3" v-if="responseTypeDoc && responseTypeDoc.value !== 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
            </div>



            <b-form-group>
              <label qid="create-q-pg-label">
                {{ $t('maintenance.questions.create.add_comment_label') }}
                <span class="text-red">*</span>
              </label>
              <multiselect
                      v-model="dataCollectionAddDescription"
                      :options="allowTypesShort"
                      :placeholder="$t('maintenance.questions.create.add_comment_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-q-form-pg"
              ></multiselect>
            </b-form-group>
            <b-form-group>
              <label qid="create-q-pg-label">
                {{ $t('maintenance.questions.create.add_attachments_label') }}
                <span class="text-red">*</span>
              </label>
              <multiselect
                      v-model="dataCollectionAddAttachments"
                      :options="allowTypes"
                      :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-q-form-pg"
              ></multiselect>
            </b-form-group>
          </div>
        </div>
        <div class="proxy-footer">
          <div class="progress-indicator-footer col text-center pt-2 pb-1">
            <ul class="progress-indicator pr-5 pl-5 mb-1">
              <li class="progress-completed">1</li>
              <li class="progress-completed">2</li>
              <li class="progress-completed">3</li>
              <li class="progress-active">4</li>
              <li class="progress-uncompleted">5</li>
            </ul>

            <ul class="progress-indicator-text pr-4 pl-4">
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.framework_controls') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
            </ul>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="showCreateQForm3('back')"
                            qid="create-q-data_collection-back-button"
                  >
                    {{ $t('maintenance.questions.create.back') }}
                  </b-button>
                  <b-button @click="showCreateQForm5('forward')"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-q-data_collection-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.questions.create.next') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </b-modal>


    <b-modal ref="add-question-5"
             @hide="hideCreateQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

        <div class="form-container">
          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.question_description_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.question_description_description') }}
            </span>
          </div>

          <b-form-group>
            <label qid="create-q-description-label">
              {{ $t('maintenance.questions.create.description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea
              qid="create-q-form-description"
              v-model="form.description"
              rows="6"
              max-rows="6"
              required
              :placeholder="$t('maintenance.questions.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <div v-show="showDropActive" class="drop-active">
              <h3>Drop files to upload</h3>
            </div>
            <label for=""> {{ $t('maintenance.questions.create.data_collection_attachment_label') }}</label>
            <div class="form-control auto-height pt-3 pb-3">
              <div class="text-center">
                <p>
                  Drag and drop files in here or
                  <file-upload
                    ref="uploaderData"
                    v-model="files"
                    :drop="true"
                    :multiple="true"
                    input-id="uploaderData"
                    name="uploaderData"
                    @dropActive="showDropActiveFunction"
                    class="text-success cursor-pointer"
                  >
                    click here
                  </file-upload>
                  to upload files you wish to display together with the description. You may also
                  <span class="text-success cursor-pointer" @click="showQuestionLinksSection = true">add links</span>
                </p>

              </div>

              <p v-for="(file, index) in files" :key="index">
                <span class="float-right text-muted cursor-pointer"
                      @click="removeMediaItem(index)"
                      qid="create-q-data_collection-link-remove"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
                {{file.name}}
              </p>
            </div>
          </b-form-group>
          <b-form-group v-if="showQuestionLinksSection">
            <label qid="create-q-link-label">
              {{ $t('links.label') }}
            </label>
            <p v-for="(link, index) in form.links" :key="index">
              <span class="float-right text-muted cursor-pointer"
                    @click="removeLinkItem(index)"
                    qid="create-q-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <a :href="link.url" target="_blank" qid="create-q-link-item">{{ link.name ? link.name : link.url }}</a>
            </p>
            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('system.link')"
                qid="create-q-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-q-links"
              ></b-form-input>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="handleLink"
                  qid="create-q-add-link"
            >
              + {{ $t('system.add_link') }}
            </span>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-description-label">
              {{ $t('maintenance.questions.create.description_two_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea
                    qid="create-q-form-description"
                    v-model="form.description_two"
                    rows="6"
                    max-rows="6"
                    required
                    :placeholder="$t('maintenance.questions.create.description_two_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <div v-show="showDropActiveTwo" class="drop-active">
              <h3>Drop files to upload</h3>
            </div>
            <label for=""> {{ $t('maintenance.questions.create.data_collection_two_attachment_label') }}</label>
            <div class="form-control auto-height pt-3 pb-3">
              <div class="text-center">
                <p>
                  Drag and drop files in here or
                  <file-upload
                          ref="uploaderDataTwo"
                          v-model="files_two"
                          :drop="true"
                          :multiple="true"
                          input-id="uploaderDataTwo"
                          name="uploaderDataTwo"
                          @input="onFileTwoChangeEdit"
                          @dropActive="showDropActiveFunctionTwo"
                          class="text-success cursor-pointer"
                  >
                    click here
                  </file-upload>
                  to upload files you wish to display together with the description. You may also
                  <span class="text-success cursor-pointer" @click="showQuestionTwoLinksSection = true">add links</span>
                </p>
              </div>

              <p v-for="(file, index) in selectedQuestion.media" :key="index">
                <span v-if="file.collection_name === 'question_two'">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteAttachmentModal(file)"
                        qid="remove-media-item"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer"
                        @click="downloadMedia(file)"
                        qid="download-media"
                  >
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
              </p>
              <div v-if="selectedQuestion.links">
                <p v-for="(link, index) in getQuestionTwoLinks" :key="index">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteLinkModal(link)"
                        qid="view-q-remove-link"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-q-link-item">
                    {{ link.name ? link.name : link.url }}
                  </a>
                </p>
              </div>
            </div>
          </b-form-group>
          <b-form-group v-if="showQuestionTwoLinksSection">
            <label qid="create-q-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>

            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                      type="text"
                      aria-describedby="inputGroup"
                      v-model="inputLink"
                      :placeholder="$t('system.link')"
                      qid="create-q-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                      type="text"
                      aria-describedby="inputGroup"
                      v-model="inputLinkName"
                      :placeholder="inputLink ? inputLink : $t('table.name')"
                      qid="create-q-links"
              ></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleEditLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_response_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addResponse"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_response_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="addResponse && addResponse.value && addResponse.value !== 'No'">
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.type_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="responseType"
                :options="responseTypes"
                group-values="items"
                group-label="group"
                :group-select="false"
                :placeholder="$t('maintenance.questions.create.type_placeholder')"
                label="name"
                @select="handleType"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value === 'Dropdown' && addResponse && addResponse.value && addResponse.value !== 'No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptions"
               :key="index"
               class="mt-1 mb-1 pb-3 pt-3"
            >
              <span class="float-right btn btn-delete"
                    @click="removeOptionItem(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <multiselect
                  v-model="option.value"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="pt-2">{{ option.title }}</span>
            </p>
            <div class="input-group pt-2">
              <b-form-input
                qid="create-p-form-link"
                type="text"
                v-if="showInput"
                v-on:keydown.enter="handleOption"
                v-model="inputOption"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"
              ></b-form-input>
              <div class="input-group-append" v-if="showInput">
                <span class="input-group-text cursor-pointer"
                      id="inputGroup"
                      @click="handleOption"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="showInput = true"
                  v-if="!showInput"
                  qid="create-p-add-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value === 'Yes/No' && addResponse && addResponse.value && addResponse.value !== 'No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect
                  v-model="yesValue"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="mt-2">Yes</span>
            </p>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect
                  v-model="noValue"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="mt-2">No</span>
            </p>
          </b-form-group>

          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value === 'Dropdown' && addResponse && addResponse.value && addResponse.value !== 'No'">
            * {{ $t('maintenance.questions.create.helper_text_label') }}
          </div>
          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value !== 'Dropdown' && addResponse && addResponse.value && addResponse.value !== 'No'">
            * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
          </div>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_notes_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addNotes"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_notes_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_testing_notes_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                    v-model="addTestingNotes"
                    :options="allowTypes"
                    :placeholder="$t('maintenance.questions.create.add_testing_notes_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="addTestingNotes && (addTestingNotes.value === 'Optional' || addTestingNotes.value === 'Mandatory')">
            <b-form-textarea
                qid="create-q-form-testing-notes-default-text"
                v-model="form.testing_notes_default_text"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.questions.create.add_testing_notes_default_text_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_control_description_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addControlDescription"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_control_description_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="addControlDescription && (addControlDescription.value === 'Optional' || addControlDescription.value === 'Mandatory')">
            <b-form-textarea
                qid="create-q-form-default-text"
                v-model="form.control_description_default_text"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.questions.create.add_control_description_default_text_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_performed_text_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addPerformedText"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_performed_text_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="addPerformedText && (addPerformedText.value === 'Optional' || addPerformedText.value === 'Mandatory')">
            <b-form-textarea
                v-model="form.performed_test_default_text"
                qid="create-q-form-default-text"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.questions.create.add_performed_test_default_text_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_description_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addDescription"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_description_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="addDescription && (addDescription.value === 'Optional' || addDescription.value === 'Mandatory')">
            <b-form-textarea
                v-model="form.conclusion_default_text"
                qid="create-q-form-default-text"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.questions.create.add_conclusion_default_text_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_attachments_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addAttachments"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>
        </div>
      <b-form @submit="formSubmit" qid="create-q-form">
        <div class="proxy-footer">
          <div class="progress-indicator-footer col text-center pt-2 pb-1">
            <ul class="progress-indicator pr-5 pl-5 mb-1">
              <li class="progress-completed">1</li>
              <li class="progress-completed">2</li>
              <li class="progress-completed">3</li>
              <li class="progress-completed">4</li>
              <li class="progress-active">5</li>
            </ul>

            <ul class="progress-indicator-text pr-4 pl-4">
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.framework_controls') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
            </ul>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="showCreateQForm4('back')"
                            qid="create-q-data_collection-back-button"
                  >
                    {{ $t('maintenance.questions.create.back') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-q-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.questions.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!--<b-modal ref="add-question-5"-->
             <!--@hide="hideCreateQModal"-->
             <!--modal-class="task-modal"-->
             <!--hide-footer-->
    <!--&gt;-->
      <!--<template #modal-header="{ close }">-->
        <!--<div class="" style="width: 100%;">-->
          <!--<span @click="hideCreateQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">-->
            <!--<font-awesome-icon icon="times"/>-->
          <!--</span>-->
          <!--<h5 class="mb-1 text-center" qid="create-q-title">-->
            <!--{{ $t('maintenance.questions.create.title') }}-->
          <!--</h5>-->
        <!--</div>-->
      <!--</template>-->

      <!--<b-alert v-if="error.length"-->
               <!--show-->
               <!--variant="danger"-->
               <!--qid="create-q-error"-->
      <!--&gt;-->
        <!--{{ error }}-->
      <!--</b-alert>-->

      <!--<b-form @submit="formSubmit" qid="create-q-form">-->
        <!--<div class="form-container">-->
          <!--<div class="mt-3 mb-3 text-center">-->
            <!--<h5>{{ $t('maintenance.questions.create.submit_success_message') }}</h5>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="proxy-footer">-->
          <!--<div class="progress-indicator-footer col text-center pt-2 pb-1">-->
            <!--<ul class="progress-indicator pr-5 pl-5 mb-1">-->
              <!--<li class="progress-completed">1</li>-->
              <!--<li class="progress-completed">2</li>-->
              <!--<li class="progress-completed">3</li>-->
              <!--<li class="progress-completed">4</li>-->
              <!--<li class="progress-active">5</li>-->
            <!--</ul>-->

            <!--<ul class="progress-indicator-text pr-4 pl-4">-->
              <!--<li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>-->
              <!--<li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>-->
              <!--<li class="text-center progress-completed">{{ $t('maintenance.questions.create.framework_controls') }}</li>-->
              <!--<li class="text-center progress-completed">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>-->
              <!--<li class="text-center progress-completed">{{ $t('maintenance.questions.create.assessment_task') }}</li>-->
            <!--</ul>-->
          <!--</div>-->
          <!--<div class="alert alert-menu-color color-secondary mb-0" role="alert">-->
            <!--<div class="row">-->
              <!--<div class="col-sm-6">-->

              <!--</div>-->
              <!--<div class="col-sm-6">-->
                <!--<div class="text-right">-->
                  <!--<b-button class=""-->
                            <!--variant="secondary"-->
                            <!--@click="showCreateQForm4"-->
                            <!--qid="create-q-back-button"-->
                  <!--&gt;-->
                    <!--{{ $t('maintenance.questions.create.back') }}-->
                  <!--</b-button>-->
                  <!--<b-button type="submit"-->
                            <!--class="ml-3"-->
                            <!--variant="success"-->
                            <!--:disabled="buttonDisabled"-->
                            <!--qid="create-q-submit-button"-->
                  <!--&gt;-->
                    <!--<span v-if="buttonDisabled" class="mr-1">-->
                      <!--<font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>-->
                    <!--</span>-->
                    <!--{{ $t('maintenance.questions.create.submit') }}-->
                  <!--</b-button>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</b-form>-->
    <!--</b-modal>-->


    <!-- Edit Assessment Control modals -->
    <b-modal ref="edit-question-1"
             @hide="hideEditQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.question_title') }}
          </h5>
          <span class="text-muted">
            {{ $t('maintenance.questions.create.question_description') }}
          </span>
        </div>

        <b-form-group>
          <label qid="create-q-name-label">
            {{ $t('maintenance.questions.create.name_label') }}
            <span class="text-red">*</span>
          </label>
          <b-form-input
            qid="create-q-form-name"
            type="text"
            v-model="form.name"
            required
            :maxLength="255"
            :placeholder="$t('maintenance.questions.create.name_placeholder')"
          ></b-form-input>
        </b-form-group>

        <b-form-group>
          <label qid="create-q-reference-label">
            {{ $t('maintenance.questions.create.reference_label') }}
          </label>
          <b-form-input
            qid="create-q-form-reference"
            type="text"
            v-model="form.reference"
            :maxLength="255"
            v-on:input="debounceInput"
            :class="{'is-invalid': referenceInvalid}"
            :placeholder="$t('maintenance.questions.create.reference_placeholder')"
          ></b-form-input>
          <b-form-invalid-feedback
              v-if="referenceInvalid"
              qid="pasword-requirement-notice"
              class="d-block"
          >
            {{ $t('maintenance.questions.create.reference_error') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group  v-if="assessment.type !== 'risk'">
          <label qid="create-assessment-control-objective-label">
            {{ $t('maintenance.control_objective.title') }}<span class="mandatory"> *</span>
          </label>
          <div class="multiselect-row">
            <multiselect
                v-model="selectedControlObjective"
                :options="controlObjectives"
                :placeholder="$t('maintenance.control_objective.title_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                required
                :allow-empty="false"
                @search-change="loadCO"
                track-by="id"
                qid="create-assessment-control-form-control-objective"
            >
              <template slot="singleLabel" slot-scope="props">
                <font-awesome-icon icon="book"/>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <font-awesome-icon icon="book"/>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
            <b-button
                class="btn btn-secondary float-right"
                @click="showCreateControlObjectiveModal()"
                qid="control-objective-create-button-fc-modal"
                v-if="isGranted(permissions.CONTROL_OBJECTIVE_CREATE) && (!getClient.parent || (getClient.parent && object.partition))"
                v-b-tooltip.hover
                :title="$t('maintenance.control_objective.add_new')"
            >
              <font-awesome-icon icon="plus-circle"/>
            </b-button>
          </div>
          <p v-if="form.control_objective && form.control_objective.name">
            <font-awesome-icon icon="book"/>
            {{ form.control_objective.name }}
          </p>
        </b-form-group>
      </div>
      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-active">1</li>
            <li class="progress-uncompleted">2</li>
            <li class="progress-uncompleted">3</li>
            <li class="progress-uncompleted">4</li>
            <li class="progress-uncompleted">5</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class=""
                          variant="secondary"
                          @click="hideEditQModal"
                          qid="create-q-cancel-button"
                >
                  {{ $t('maintenance.questions.create.cancel') }}
                </b-button>
                <b-button
                          class="ml-3"
                          variant="success"
                          :disabled="buttonDisabled"
                          @click="showEditQForm2('forward')"
                          qid="create-q-submit-button"
                >
                  <span v-if="buttonDisabled" class="mr-1">
                    <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                  </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal ref="edit-question-2"
             @hide="hideEditQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

      <div class="form-container">
        <div class="mb-3">
          <h5 class="mb-2">
            {{ $t('maintenance.questions.create.linked_controls_title') }}
          </h5>
          <span class="text-muted">
              {{ $t('maintenance.questions.create.linked_controls_description') }}
            </span>
        </div>

        <div class="">
          <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6 text-right">
              <button class="btn btn-success"
                      qid="frameworkControl-create-button"
                      @click="showAddLinkedControlModal"
              >
                <font-awesome-icon icon="plus"/> {{ $t('generic_controls.linked_controls.create_button') }}
              </button>
            </div>
          </div>
          <table class="table table-responsive-md table-list-secondary">
            <thead>
            <tr>
              <th scope="col">
                {{ $t('generic_controls.linked_controls.name') }}
              </th>
              <th width="100"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in selectedLinkedControls" :key="'table-row-' + index" :id="'table-row-' + index">
              <td scope="row">
                    <span v-if="item.assessment && item.assessment.name" class="text-muted">
                      {{ item.assessment.name }}
                    </span>
                    <br>
                    <span v-if="item && item.name">
                      <span v-if="item.reference">{{ item.reference }}:</span> {{ item.name }}
                    </span>
                <br>
              </td>
              <td>
                <button
                        class="btn btn-delete float-right"
                        qid="delete-framework_control-modal"
                        @click="removeLinkedControlItem(index)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </button>
              </td>
            </tr>
            <tr v-for="(item, index) in selectedLinkedControlsAsTarget" :key="'table-row-' + index" :id="'table-row-' + index">
              <td scope="row">
                    <span v-if="item.assessment_name" class="text-muted">
                      {{ item.assessment_name }}
                    </span>
                <br>
                <span v-if="item && item.name">
                      <span v-if="item.reference">{{ item.reference }}:</span> {{ item.name }}
                    </span>
                <br>
              </td>
              <td>
              </td>
            </tr>
            <tr v-if="!selectedLinkedControls.length && !selectedLinkedControlsAsTarget.length" qid="no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="proxy-footer">
        <div class="progress-indicator-footer col text-center pt-2 pb-1">
          <ul class="progress-indicator pr-5 pl-5 mb-1">
            <li class="progress-completed">1</li>
            <li class="progress-active">2</li>
            <li class="progress-uncompleted">3</li>
            <li class="progress-uncompleted">4</li>
            <li class="progress-uncompleted">5</li>
          </ul>

          <ul class="progress-indicator-text pr-4 pl-4">
            <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.linked_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
            <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
          </ul>
        </div>
        <div class="alert alert-menu-color color-secondary mb-0" role="alert">
          <div class="row">
            <div class="col-sm-6">

            </div>
            <div class="col-sm-6">
              <div class="text-right">
                <b-button class=""
                          variant="secondary"
                          @click="showEditQForm1"
                          qid="create-q-cancel-button"
                >
                  {{ $t('maintenance.questions.create.back') }}
                </b-button>
                <b-button @click="showEditQForm3('forward')"
                          class="ml-3"
                          variant="success"
                          :disabled="buttonDisabled"
                          qid="create-q-submit-button"
                >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                  {{ $t('maintenance.questions.create.next') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal ref="edit-question-3"
             @hide="hideEditQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

        <div class="form-container">
          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.framework_controls_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.framework_controls_description') }}
            </span>
          </div>

          <div class="">
            <div class="row">
              <div class="col-sm-6">
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-success"
                        qid="frameworkControl-create-button"
                        @click="showAddFrameworkControlModal"
                >
                  <font-awesome-icon icon="plus"/> {{ $t('generic_controls.framework_controls.create_button') }}
                </button>
              </div>
            </div>
            <table class="table table-responsive-md table-list-secondary">
              <thead>
                <tr>
                  <th scope="col">
                    {{ $t('generic_controls.framework_controls.name') }}
                  </th>
                  <th width="100"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in selectedFrameworkControls" :key="'table-row-' + index" :id="'table-row-' + index">
                  <b-popover
                      :target="'table-row-' + index"
                      boundary="viewport"
                      triggers="hover"
                      placement="topleft"
                      :delay="{ show: 500, hide: 0 }"
                  >
                    <div v-if="item.active_framework && item.active_framework.name" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.questions.create.active_framework_name_label') }}:
                      </span>
                      <br>
                      {{ item.active_framework.name }}
                      <br>
                    </div>
                    <div v-if="item.control_objective && item.control_objective.name" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.questions.create.control_objective_name_label') }}:
                      </span>
                      <br>
                      {{ item.control_objective.name }}
                      <br>
                    </div>
                    <div v-if="item.control_objective && item.control_objective.description" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.questions.create.control_objective_description_label') }}:
                      </span>
                      <br>
                      {{ item.control_objective.description | truncate(200)}}
                      <br>
                    </div>
                    <div v-if="item && item.name" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.framework_control.table.name') }}:
                      </span>
                      <br>
                      {{ item.name }}
                      <br>
                    </div>
                    <div v-if="item.description" class="mt-2">
                      <span class="text-bold">
                        {{ $t('maintenance.framework_control.create.description_label') }}:
                      </span>
                      <br>
                      {{ item.description | truncate(200)}}
                      <br>
                    </div>
                  </b-popover>
                  <td scope="row">
                    <span v-if="item.active_framework && item.active_framework.name" class="text-muted">
                      {{ item.active_framework.name }}
                    </span>
                    <br>
                    <span>
                      {{ item.full_name }}
                    </span>
                  </td>
                  <td>
                    <button
                        class="btn btn-delete float-right"
                        qid="delete-framework_control-modal"
                        @click="removeFrameworkControlItem(index)"
                    >
                      <font-awesome-icon icon="trash-alt"/>
                    </button>
                  </td>
                </tr>
                <tr v-if="!selectedFrameworkControls.length" qid="no-results-row" class="text-center">
                  <td colspan="10">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="proxy-footer">
          <div class="progress-indicator-footer col text-center pt-2 pb-1">
            <ul class="progress-indicator pr-5 pl-5 mb-1">
              <li class="progress-completed">1</li>
              <li class="progress-completed">2</li>
              <li class="progress-active">3</li>
              <li class="progress-uncompleted">4</li>
              <li class="progress-uncompleted">5</li>
            </ul>

            <ul class="progress-indicator-text pr-4 pl-4">
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.framework_controls') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
            </ul>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="showEditQForm2"
                            qid="create-q-cancel-button"
                  >
                    {{ $t('maintenance.questions.create.back') }}
                  </b-button>
                  <b-button @click="showEditQForm4('forward')"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-q-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.questions.create.next') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </b-modal>

    <b-modal ref="edit-question-4"
             @hide="hideEditQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

        <div class="form-container">
          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.question_data_collection_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.question_data_collection_description') }}
            </span>
          </div>

          <div class="form-group">
            <label qid="create-q-data_collection-radio-label">
              {{ $t('maintenance.questions.create.data_collection_label') }}
            </label>
            <b-form-radio-group
                v-model="data_collection_on"
                :options="dataCollectionOptions"
                @change="lockSwitch(data_collection_on)"
                qid="create-q-data_collection-radio-option"
            ></b-form-radio-group>
          </div>
          <div v-if="data_collection_on">
            <b-form-group>
              <label qid="create-q-data_collection-description-label">
                {{ $t('maintenance.questions.create.data_collection_description_label') }}
                <span class="text-red">*</span>
              </label>
              <b-form-textarea
                      qid="create-q-data_collection-form-description"
                      v-model="form.data_collection_description"
                      rows="6"
                      max-rows="6"
                      required
                      :placeholder="$t('maintenance.questions.create.data_collection_description_placeholder')"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group>
              <div v-show="showDropActive" class="drop-active">
                <h3>Drop files to upload</h3>
              </div>

              <label> {{ $t('maintenance.questions.create.data_collection_attachment_label') }}</label>

              <div class="form-control auto-height pt-3 pb-3">
                <div class="text-center">
                  <p>
                    Drag and drop files in here or
                    <file-upload
                            ref="uploaderData"
                            v-model="data_collection_files"
                            :drop="true"
                            :multiple="true"
                            input-id="uploaderData"
                            name="uploaderData"
                            @input="onFileChangeDataCollectionEdit"
                            @dropActive="showDropActiveFunction"
                            class="text-success cursor-pointer"
                    >
                      click here
                    </file-upload>
                    to upload files you wish to display together with the description. You may also
                    <span class="text-success cursor-pointer" @click="showLinksSection = true">add links</span>
                  </p>
                </div>

                <p v-for="(file, media_index) in selectedQuestion.media" :key="media_index">
                <span v-if="file.collection_name == 'data_collection'">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteAttachmentModal(file)"
                        qid="remove-media-item"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer"
                        @click="downloadMedia(file)"
                        qid="download-media"
                  >
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
                </p>

                <div v-if="selectedQuestion.links">
                  <p v-for="(link, link_index) in getDataCollectionLinks" :key="link_index">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteLinkModal(link)"
                        qid="view-q-remove-link"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                    <a :href="link.url" target="_blank" qid="create-q-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </div>
            </b-form-group>

            <b-form-group v-if="showLinksSection">
              <label qid="create-q-link-label">
                {{ $t('maintenance.third_parties.create.links_label') }}
              </label>

              <div>
                <label class="mt-2">{{ $t('system.link') }}</label>
                <b-form-input
                        type="text"
                        aria-describedby="inputGroup"
                        v-model="inputLinkDataCollection"
                        :placeholder="$t('system.link')"
                        qid="create-q-links"
                ></b-form-input>
                <label class="mt-2">{{ $t('table.name') }}</label>
                <b-form-input
                        type="text"
                        aria-describedby="inputGroup"
                        v-model="inputLinkNameDataCollection"
                        :placeholder="inputLinkDataCollection ? inputLinkDataCollection : $t('table.name')"
                        qid="create-q-links"
                ></b-form-input>
                <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleEditDataCollectionLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
                </div>
              </div>
            </b-form-group>

            <b-form-group>
              <label qid="create-q-data_collection-description-label">
                {{ $t('maintenance.questions.create.data_collection_description_two_label') }}
                <span class="text-red">*</span>
              </label>
              <b-form-textarea
                      qid="create-q-data_collection-form-description"
                      v-model="form.data_collection_description_two"
                      rows="6"
                      max-rows="6"
                      required
                      :placeholder="$t('maintenance.questions.create.data_collection_description_two_placeholder')"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group>
              <div v-show="showDropActive" class="drop-active">
                <h3>Drop files to upload</h3>
              </div>

              <label> {{ $t('maintenance.questions.create.data_collection_two_attachment_label') }}</label>

              <div class="form-control auto-height pt-3 pb-3">
                <div class="text-center">
                  <p>
                    Drag and drop files in here or
                    <file-upload-two
                            ref="uploaderDataTwo"
                            v-model="data_collection_two_files"
                            :drop="true"
                            :multiple="true"
                            input-id="uploaderDataTwo"
                            name="uploaderDataTwo"
                            @input="onFileChangeDataCollectionTwoEdit"
                            @dropActive="showDropActiveFunctionTwo"
                            class="text-success cursor-pointer"
                    >
                      click here
                    </file-upload-two>
                    to upload files you wish to display together with the description. You may also
                    <span class="text-success cursor-pointer" @click="showLinksSectionTwo = true">add links</span>
                  </p>
                </div>

                <p v-for="(file, media_index) in selectedQuestion.media" :key="media_index">
                <span v-if="file.collection_name == 'data_collection_two'">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteAttachmentModal(file)"
                        qid="remove-media-item"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer"
                        @click="downloadMedia(file)"
                        qid="download-media"
                  >
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
                </p>

                <div v-if="selectedQuestion.links">
                  <p v-for="(link, link_index) in getDataCollectionTwoLinks" :key="link_index">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteLinkModal(link)"
                        qid="view-q-remove-link"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                    <a :href="link.url" target="_blank" qid="create-q-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </div>
            </b-form-group>


            <b-form-group v-if="showLinksSectionTwo">
              <label qid="create-q-link-label">
                {{ $t('maintenance.third_parties.create.links_label') }}
              </label>

              <div>
                <label class="mt-2">{{ $t('system.link') }}</label>
                <b-form-input
                        type="text"
                        aria-describedby="inputGroup"
                        v-model="inputLinkDataCollection"
                        :placeholder="$t('system.link')"
                        qid="create-q-links"
                ></b-form-input>
                <label class="mt-2">{{ $t('table.name') }}</label>
                <b-form-input
                        type="text"
                        aria-describedby="inputGroup"
                        v-model="inputLinkNameDataCollection"
                        :placeholder="inputLinkDataCollection ? inputLinkDataCollection : $t('table.name')"
                        qid="create-q-links"
                ></b-form-input>
                <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleEditDataCollectionTwoLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
                </div>
              </div>
            </b-form-group>

            <!--Documentation Response-->
            <b-form-group>
              <label qid="create-q-pg-label">
                {{ $t('maintenance.questions.create.add_response_label') }}
                <span class="text-red">*</span>
              </label>
              <multiselect
                      v-model="addResponseDoc"
                      :options="allowTypesDoc"
                      :placeholder="$t('maintenance.questions.create.add_response_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-q-form-pg"
              ></multiselect>
            </b-form-group>

            <b-form-group v-if="addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              <label qid="create-q-pg-label">
                {{ $t('maintenance.questions.create.type_label') }}
                <span class="text-red">*</span>
              </label>

              <multiselect
                      v-model="responseTypeDoc"
                      :options="responseTypes"
                      group-values="items"
                      group-label="group"
                      :group-select="false"
                      :placeholder="$t('maintenance.questions.create.type_placeholder')"
                      label="name"
                      @select="handleTypeDoc"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-q-form-pg"
              ></multiselect>
            </b-form-group>

            <b-form-group v-if="responseTypeDoc && responseTypeDoc.value === 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              <label qid="create-p-link-label">
                {{ $t('maintenance.questions.create.options_label') }}
                <span class="text-red">*</span>
              </label>
              <p v-for="(option, index) in selectedOptionsDoc"
                 :key="index"
                 class="mt-1 mb-1 pb-3 pt-3"
              >
              <span class="float-right btn btn-delete"
                    @click="removeOptionItemDoc(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
                <multiselect
                        v-model="option.value"
                        :options="answerTypes"
                        group-values="items"
                        group-label="group"
                        :group-select="false"
                        :placeholder="$t('maintenance.questions.create.type_placeholder')"
                        label="name"
                        :select-label="''"
                        :selected-label="''"
                        :deselect-label="''"
                        class="float-right mr-2"
                        style="width:220px;"
                        :allow-empty="false"
                        qid="create-p-form-pg"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                    <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                  </template>
                </multiselect>
                <span class="pt-2">{{ option.title }}</span>
              </p>
              <div class="input-group pt-2">
                <b-form-input
                        qid="create-p-form-link"
                        type="text"
                        v-if="showInputDoc"
                        v-on:keydown.enter="handleOptionDoc"
                        v-model="inputOptionDoc"
                        :placeholder="$t('maintenance.questions.create.options_placeholder')"
                ></b-form-input>
                <div class="input-group-append" v-if="showInputDoc">
                <span class="input-group-text cursor-pointer"
                      id="inputGroupDoc"
                      @click="handleOptionDoc"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
                </div>
              </div>
              <span class="btn btn-link cursor-pointer float-right"
                    @click="showInputDoc = true"
                    v-if="!showInputDoc"
                    qid="create-p-add-link"
              >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
            </b-form-group>

            <b-form-group v-if="responseTypeDoc && responseTypeDoc.value === 'Yes/No' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              <label qid="create-p-link-label">
                {{ $t('maintenance.questions.create.options_label') }}
                <span class="text-red">*</span>
              </label>
              <p class="mt-1 mb-1 pb-3 pt-3">
                <multiselect
                        v-model="yesValueDoc"
                        :options="answerTypes"
                        group-values="items"
                        group-label="group"
                        :group-select="false"
                        :placeholder="$t('maintenance.questions.create.type_placeholder')"
                        label="name"
                        :select-label="''"
                        :selected-label="''"
                        :deselect-label="''"
                        class="float-right mr-2"
                        style="width:220px;"
                        :allow-empty="false"
                        qid="create-p-form-pg"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                    <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                  </template>
                </multiselect>
                <span class="mt-2">Yes</span>
              </p>
              <p class="mt-1 mb-1 pb-3 pt-3">
                <multiselect
                        v-model="noValueDoc"
                        :options="answerTypes"
                        group-values="items"
                        group-label="group"
                        :group-select="false"
                        :placeholder="$t('maintenance.questions.create.type_placeholder')"
                        label="name"
                        :select-label="''"
                        :selected-label="''"
                        :deselect-label="''"
                        class="float-right mr-2"
                        style="width:220px;"
                        :allow-empty="false"
                        qid="create-p-form-pg"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <font-awesome-icon icon="check-circle"
                                       class="icon-success"
                                       v-if="props.option.value === 'Positive'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="times-circle"
                                       class="icon-danger"
                                       v-if="props.option.value === 'Negative'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="info-circle"
                                       class="icon-info"
                                       v-if="props.option.value === 'Neutral'"
                                       style="background:white;border-radius:50%;"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-1'"
                                       v-if="props.option.value === 'Very low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-3'"
                                       v-if="props.option.value === 'Low'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-9'"
                                       v-if="props.option.value === 'High'"/>
                    <font-awesome-icon icon="exclamation-triangle"
                                       :class="'risk-16'"
                                       v-if="props.option.value === 'Very high'"/>
                    <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                    <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                  </template>
                </multiselect>
                <span class="mt-2">No</span>
              </p>
            </b-form-group>

            <div class="text-muted mt-2 mb-3" v-if="responseTypeDoc && responseTypeDoc.value === 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              * {{ $t('maintenance.questions.create.helper_text_label') }}
            </div>
            <div class="text-muted mt-2 mb-3" v-if="responseTypeDoc && responseTypeDoc.value !== 'Dropdown' && addResponseDoc && addResponseDoc.value && addResponseDoc.value !== 'No'">
              * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
            </div>
            <b-form-group>
              <label qid="create-q-pg-label">
                {{ $t('maintenance.questions.create.add_comment_label') }}
                <span class="text-red">*</span>
              </label>
              <multiselect
                      v-model="dataCollectionAddDescription"
                      :options="allowTypesShort"
                      :placeholder="$t('maintenance.questions.create.add_comment_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-q-form-pg"
              ></multiselect>
            </b-form-group>
            <b-form-group>
              <label qid="create-q-pg-label">
                {{ $t('maintenance.questions.create.add_attachments_label') }}
                <span class="text-red">*</span>
              </label>
              <multiselect
                      v-model="dataCollectionAddAttachments"
                      :options="allowTypes"
                      :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')"
                      label="name"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      qid="create-q-form-pg"
              ></multiselect>
            </b-form-group>
          </div>
        </div>
        <div class="proxy-footer">
          <div class="progress-indicator-footer col text-center pt-2 pb-1">
            <ul class="progress-indicator pr-5 pl-5 mb-1">
              <li class="progress-completed">1</li>
              <li class="progress-completed">2</li>
              <li class="progress-completed">3</li>
              <li class="progress-active">4</li>
              <li class="progress-uncompleted">5</li>
            </ul>

            <ul class="progress-indicator-text pr-4 pl-4">
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.framework_controls') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
            </ul>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="showEditQForm3('back')"
                            qid="create-q-data_collection-back-button"
                  >
                    {{ $t('maintenance.questions.create.back') }}
                  </b-button>
                  <b-button
                            class="ml-3"
                            variant="success"
                            @click="showEditQForm5('forward')"
                            :disabled="buttonDisabled"
                            qid="create-q-data_collection-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.questions.create.next') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </b-modal>


    <b-modal ref="edit-question-5"
             @hide="hideEditQModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditQModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-q-title">
            {{ $t('maintenance.questions.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-q-error"
      >
        {{ error }}
      </b-alert>

        <div class="form-container">
          <div class="mb-3">
            <h5 class="mb-2">
              {{ $t('maintenance.questions.create.question_description_title') }}
            </h5>
            <span class="text-muted">
              {{ $t('maintenance.questions.create.question_description_description') }}
            </span>
          </div>

          <b-form-group>
            <label qid="create-q-description-label">
              {{ $t('maintenance.questions.create.description_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea
              qid="create-q-form-description"
              v-model="form.description"
              rows="6"
              max-rows="6"
              required
              :placeholder="$t('maintenance.questions.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <div v-show="showDropActive" class="drop-active">
              <h3>Drop files to upload</h3>
            </div>
            <label for=""> {{ $t('maintenance.questions.create.data_collection_attachment_label') }}</label>
            <div class="form-control auto-height pt-3 pb-3">
              <div class="text-center">
                <p>
                  Drag and drop files in here or
                  <file-upload
                    ref="uploader"
                    v-model="files"
                    :drop="true"
                    :multiple="true"
                    input-id="uploader"
                    name="uploader"
                    @input="onFileChangeEdit"
                    @dropActive="showDropActiveFunction"
                    class="text-success cursor-pointer"
                  >
                    click here
                  </file-upload>
                  to upload files you wish to display together with the description. You may also
                  <span class="text-success cursor-pointer" @click="showQuestionLinksSection = true">add links</span>
                </p>
              </div>

              <p v-for="(file, index) in selectedQuestion.media" :key="index">
                <span v-if="file.collection_name === 'question' || file.collection_name === 'documents'">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteAttachmentModal(file)"
                        qid="remove-media-item"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer"
                        @click="downloadMedia(file)"
                        qid="download-media"
                  >
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
              </p>
              <div v-if="selectedQuestion.links">
                <p v-for="(link, index) in getQuestionLinks" :key="index">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteLinkModal(link)"
                        qid="view-q-remove-link"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-q-link-item">
                    {{ link.name ? link.name : link.url }}
                  </a>
                </p>
              </div>
            </div>
          </b-form-group>
          <b-form-group v-if="showQuestionLinksSection">
            <label qid="create-q-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>

            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('system.link')"
                qid="create-q-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-q-links"
              ></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleEditLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-description-label">
              {{ $t('maintenance.questions.create.description_two_label') }}
              <span class="text-red">*</span>
            </label>
            <b-form-textarea
                    qid="create-q-form-description"
                    v-model="form.description_two"
                    rows="6"
                    max-rows="6"
                    required
                    :placeholder="$t('maintenance.questions.create.description_two_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <div v-show="showDropActiveTwo" class="drop-active">
              <h3>Drop files to upload</h3>
            </div>
            <label for=""> {{ $t('maintenance.questions.create.data_collection_two_attachment_label') }}</label>
            <div class="form-control auto-height pt-3 pb-3">
              <div class="text-center">
                <p>
                  Drag and drop files in here or
                  <file-upload
                          ref="uploaderTwo"
                          v-model="files_two"
                          :drop="true"
                          :multiple="true"
                          input-id="uploaderTwo"
                          name="uploaderTwo"
                          @input="onFileTwoChangeEdit"
                          @dropActive="showDropActiveFunctionTwo"
                          class="text-success cursor-pointer"
                  >
                    click here
                  </file-upload>
                  to upload files you wish to display together with the description. You may also
                  <span class="text-success cursor-pointer" @click="showQuestionTwoLinksSection = true">add links</span>
                </p>
              </div>

              <p v-for="(file, index) in selectedQuestion.media" :key="index">
                <span v-if="file.collection_name === 'question_two'">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteAttachmentModal(file)"
                        qid="remove-media-item"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer"
                        @click="downloadMedia(file)"
                        qid="download-media"
                  >
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a @click="downloadMedia(file)" qid="create-q-media-item">
                    {{ file.file_name }}
                  </a>
                </span>
              </p>
              <div v-if="selectedQuestion.links">
                <p v-for="(link, index) in getQuestionTwoLinks" :key="index">
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteLinkModal(link)"
                        qid="view-q-remove-link"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-q-link-item">
                    {{ link.name ? link.name : link.url }}
                  </a>
                </p>
              </div>
            </div>
          </b-form-group>
          <b-form-group v-if="showQuestionTwoLinksSection">
            <label qid="create-q-link-label">
              {{ $t('maintenance.third_parties.create.links_label') }}
            </label>

            <div>
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                      type="text"
                      aria-describedby="inputGroup"
                      v-model="inputLink"
                      :placeholder="$t('system.link')"
                      qid="create-q-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                      type="text"
                      aria-describedby="inputGroup"
                      v-model="inputLinkName"
                      :placeholder="inputLink ? inputLink : $t('table.name')"
                      qid="create-q-links"
              ></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleEditLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_response_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addResponse"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_response_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="addResponse && addResponse.value && addResponse.value !== 'No'">
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.type_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="responseType"
                :options="responseTypes"
                group-values="items"
                group-label="group"
                :group-select="false"
                :placeholder="$t('maintenance.questions.create.type_placeholder')"
                label="name"
                @select="handleType"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value === 'Dropdown' && addResponse && addResponse.value && addResponse.value !== 'No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p v-for="(option, index) in selectedOptions"
               :key="index"
               class="mt-1 mb-1 pb-3 pt-3"
            >
              <span class="float-right btn btn-delete"
                    @click="removeOptionItem(index, option)"
                    qid="create-p-link-remove"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <multiselect
                  v-model="option.value"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="pt-2">{{ option.title }}</span>
            </p>
            <div class="input-group pt-2">
              <b-form-input
                qid="create-p-form-link"
                type="text"
                v-if="showInput"
                v-on:keydown.enter="handleOption"
                v-model="inputOption"
                :placeholder="$t('maintenance.questions.create.options_placeholder')"
              ></b-form-input>
              <div class="input-group-append" v-if="showInput">
                <span class="input-group-text cursor-pointer"
                      id="inputGroup"
                      @click="handleOption"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer float-right"
                  @click="showInput = true"
                  v-if="!showInput"
                  qid="create-p-add-link"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
            </span>
          </b-form-group>

          <b-form-group v-if="responseType && responseType.value === 'Yes/No' && addResponse && addResponse.value && addResponse.value !== 'No'">
            <label qid="create-p-link-label">
              {{ $t('maintenance.questions.create.options_label') }}
              <span class="text-red">*</span>
            </label>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect
                  v-model="yesValue"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="mt-2">Yes</span>
            </p>
            <p class="mt-1 mb-1 pb-3 pt-3">
              <multiselect
                  v-model="noValue"
                  :options="answerTypes"
                  group-values="items"
                  group-label="group"
                  :group-select="false"
                  :placeholder="$t('maintenance.questions.create.type_placeholder')"
                  label="name"
                  :select-label="''"
                  :selected-label="''"
                  :deselect-label="''"
                  class="float-right mr-2"
                  style="width:220px;"
                  :allow-empty="false"
                  qid="create-p-form-pg"
              >
                <template slot="singleLabel" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <font-awesome-icon icon="check-circle"
                                     class="icon-success"
                                     v-if="props.option.value === 'Positive'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="times-circle"
                                     class="icon-danger"
                                     v-if="props.option.value === 'Negative'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="info-circle"
                                     class="icon-info"
                                     v-if="props.option.value === 'Neutral'"
                                     style="background:white;border-radius:50%;"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-1'"
                                     v-if="props.option.value === 'Very low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-3'"
                                     v-if="props.option.value === 'Low'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-9'"
                                     v-if="props.option.value === 'High'"/>
                  <font-awesome-icon icon="exclamation-triangle"
                                     :class="'risk-16'"
                                     v-if="props.option.value === 'Very high'"/>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                  <span v-if="props.option.$groupLabel">
                    {{ props.option.$groupLabel }}
                  </span>
                </template>
              </multiselect>
              <span class="mt-2">No</span>
            </p>
          </b-form-group>

          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value === 'Dropdown' && addResponse && addResponse.value && addResponse.value !== 'No'">
            * {{ $t('maintenance.questions.create.helper_text_label') }}
          </div>
          <div class="text-muted mt-2 mb-3" v-if="responseType && responseType.value !== 'Dropdown' && addResponse && addResponse.value && addResponse.value !== 'No'">
            * {{ $t('maintenance.questions.create.yes_no_helper_text_label') }}
          </div>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_notes_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addNotes"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_notes_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_testing_notes_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                    v-model="addTestingNotes"
                    :options="allowTypes"
                    :placeholder="$t('maintenance.questions.create.add_testing_notes_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="addTestingNotes && (addTestingNotes.value === 'Optional' || addTestingNotes.value === 'Mandatory')">
            <b-form-textarea
                qid="create-q-form-testing-notes-default-text"
                v-model="form.testing_notes_default_text"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.questions.create.add_testing_notes_default_text_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_control_description_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addControlDescription"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_control_description_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="addControlDescription && (addControlDescription.value === 'Optional' || addControlDescription.value === 'Mandatory')">
            <b-form-textarea
                qid="create-q-form-default-text"
                v-model="form.control_description_default_text"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.questions.create.add_control_description_default_text_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_performed_text_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addPerformedText"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_performed_text_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="addPerformedText && (addPerformedText.value === 'Optional' || addPerformedText.value === 'Mandatory')">
            <b-form-textarea
                qid="create-q-form-default-text"
                v-model="form.performed_test_default_text"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.questions.create.add_performed_test_default_text_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_description_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addDescription"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_description_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>

          <b-form-group v-if="addDescription && (addDescription.value === 'Optional' || addDescription.value === 'Mandatory')">
            <b-form-textarea
                qid="create-q-form-default-text"
                v-model="form.conclusion_default_text"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.questions.create.add_conclusion_default_text_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group>
            <label qid="create-q-pg-label">
              {{ $t('maintenance.questions.create.add_attachments_label') }}
              <span class="text-red">*</span>
            </label>
            <multiselect
                v-model="addAttachments"
                :options="allowTypes"
                :placeholder="$t('maintenance.questions.create.add_attachments_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-q-form-pg"
            ></multiselect>
          </b-form-group>
        </div>

        <b-form @submit="editFormSubmit" qid="create-q-form">
        <div class="proxy-footer">
          <div class="progress-indicator-footer col text-center pt-2 pb-1">
            <ul class="progress-indicator pr-5 pl-5 mb-1">
              <li class="progress-completed">1</li>
              <li class="progress-completed">2</li>
              <li class="progress-completed">3</li>
              <li class="progress-completed">4</li>
              <li class="progress-active">5</li>
            </ul>

            <ul class="progress-indicator-text pr-4 pl-4">
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.naming') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.linked_controls') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.framework_controls') }}</li>
              <li class="text-center progress-completed">{{ $t('maintenance.questions.create.documentation_collection_task') }}</li>
              <li class="text-center progress-uncompleted">{{ $t('maintenance.questions.create.assessment_task') }}</li>
            </ul>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="showEditQForm4('back')"
                            qid="create-q-data_collection-back-button"
                  >
                    {{ $t('maintenance.questions.create.back') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-q-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.questions.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </b-form>
    </b-modal>

    <!-- Add new linked control -->
    <b-modal ref="add-linked-control" hide-footer @hide="hideAddLinkedControlModal">
      <div class="d-block text-center">
        <h4 qid="add-io-title text-white">
          {{ $t('generic_controls.linked_controls.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-io-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="linkedControlFormSubmit" qid="create-framework-control-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-framework-control-pg-label ">
              {{ $t('generic_controls.linked_controls.create.framework_label') }}
            </label>
            <multiselect
                    v-model="selectedAssessment"
                    :options="assessmentItems"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('generic_controls.linked_controls.create.framework_placeholder')"
                    label="name"
                    @search-change="loadAssessmentItems"
                    @select="handleAssessmentChange"
                    track-by="slug"
                    qid="create-lb-form-pg"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedAssessment && selectedAssessment.id">
            <label qid="create-framework-control-pg-label">
              {{ $t('generic_controls.linked_controls.create.framework_control_label') }}
            </label>
            <multiselect
                    v-model="selectedLinkedControl"
                    :options="assessmentControlItems"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('generic_controls.linked_controls.create.framework_control_placeholder')"
                    :custom-label="formatOptionLabel"
                    @search-change="loadAssessmentControlItems"
                    track-by="slug"
                    qid="create-lb-form-pg"
            ></multiselect>
          </b-form-group>
          <div class="text-muted mt-2 mb-3">
            {{ $t('generic_controls.linked_controls.create.framework_control_tip') }}
          </div>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideAddLinkedControlModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('generic_controls.framework_controls.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('generic_controls.framework_controls.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Add new framework control -->
    <b-modal ref="add-framework-control" hide-footer @hide="hideAddFrameworkControlModal">
      <div class="d-block text-center">
        <h4 qid="add-io-title">
          {{ $t('generic_controls.framework_controls.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-io-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="frameworkControlFormSubmit" qid="create-framework-control-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-framework-control-pg-label">
              {{ $t('generic_controls.framework_controls.create.framework_label') }}
            </label>
            <multiselect
                v-model="selectedFramework"
                :options="frameworkItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('generic_controls.framework_controls.create.framework_placeholder')"
                label="name"
                @search-change="loadFrameworkItems"
                @select="handleFrameworkChange"
                track-by="slug"
                qid="create-lb-form-pg"
            ></multiselect>
          </b-form-group>
          <b-form-group v-if="selectedFramework && selectedFramework.id">
            <label qid="create-framework-control-pg-label">
              {{ $t('generic_controls.framework_controls.create.framework_control_label') }}
            </label>
            <multiselect
                v-model="selectedFrameworkControl"
                :options="frameworkControlItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('generic_controls.framework_controls.create.framework_control_placeholder')"
                label="full_name"
                @search-change="loadFrameworkControlItems"
                track-by="id"
                qid="create-lb-form-pg"
            ></multiselect>
          </b-form-group>
          <div class="text-muted mt-2 mb-3">
            {{ $t('generic_controls.framework_controls.create.framework_control_tip') }}
          </div>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideAddFrameworkControlModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('generic_controls.framework_controls.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('generic_controls.framework_controls.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Add new control objective -->
    <b-modal ref="add-control-objective"
             @hide="hideCreateControlObjectiveModal"
             modal-class="task-modal"
             hide-footer
    >
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreateControlObjectiveModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="add-co-title">
            {{ $t('maintenance.control_objective.create.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="add-co-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="coFormSubmit" qid="create-co-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-control-objective-name-label">
              {{ $t('maintenance.control_objective.create.name_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
                qid="create-control-objective-form-name"
                type="text"
                v-model="coForm.name"
                :maxLength="255"
                required
                :placeholder="$t('maintenance.control_objective.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-control-objective-description-label">
              {{ $t('maintenance.control_objective.create.description_label') }}
            </label>
            <b-form-textarea
                qid="create-control-objective-form-description"
                v-model="coForm.description"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.control_objective.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>

        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreateControlObjectiveModal"
                            qid="create-control-objective-cancel-button"
                  >
                    {{ $t('maintenance.control_objective.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-control-objective-submit-button"
                  >
                        <span v-if="buttonDisabled" class="mr-1">
                          <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                        </span>
                    {{ $t('maintenance.control_objective.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!-- Edit Control Objective modal template -->
    <b-modal ref="edit-control-objective" @hide="hideEditCOModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditCOModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-tp-title">
            {{ $t('maintenance.control_objective.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-oc-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="editCOFormSubmit" qid="edit-oc-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-oc-name-label">
              {{ $t('maintenance.control_objective.create.name_label') }}
            </label>
            <span class="text-red">*</span>
            <b-form-input
              qid="edit-oc-form-name"
              type="text"
              v-model="coForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.control_objective.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-control-objective-description-label">
              {{ $t('maintenance.control_objective.create.description_label') }}
            </label>
            <b-form-textarea
                qid="create-control-objective-form-description"
                v-model="coForm.description"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.control_objective.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditCOModal"
                            qid="edit-oc-cancel-button"
                  >
                    {{ $t('maintenance.control_objective.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="editCOFormSubmit"
                            :disabled="buttonDisabled"
                            qid="edit-oc-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.control_objective.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Delete Control Objective confirm modal template -->
    <b-modal ref="delete-control-objective" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteCOModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-m-title">
            {{ $t('maintenance.control_objective.delete.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="delete-co-error"
      >
        {{ error }}
      </b-alert>

      <div class="mb-2 mt-3" style="font-size:18px;">
        <div>
          {{ $t('maintenance.control_objective.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.control_objective.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-3"
                            variant="secondary"
                            @click="hideConfirmDeleteCOModal"
                            qid="delete-co-cancel-button"
                  >
                    {{ $t('maintenance.control_objective.delete.cancel') }}
                  </b-button>
                  <b-button @click="confirmDeleteCO(itemToDelete)"
                            class="mt-3 ml-3"
                            variant="danger"
                            qid="delete-co-submit-button"
                            :disabled="buttonDisabled"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.control_objective.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>

    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import draggable from 'vuedraggable';
  import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'QuestionsTable',
    data: function() {
      return {
        form: {
          name: '',
          description: '',
          description_two: '',
          reference: '',
          control_objective: {},
          links: [],
          data_collection_links: [],
          data_collection_description: '',
          data_collection_description_two: '',
          control_description_default_text: '',
          testing_notes_default_text: '',
          conclusion_default_text: '',
          performed_test_default_text: '',
        },
        selectedControlObjective: [],
        assessmentControlOpen: false,
        controlObjectives: [],
        coForm: {
          name: '',
          description: ''
        },
        files: [],
        files_two: [],
        data_collection_files: [],
        data_collection_two_files: [],
        data_collection_on: 0,
        responseType: [],
        responseTypeDoc: [],
        addControlDescription: [],
        addNotes: [],
        addTestingNotes: [],
        addPerformedText: [],
        addDescription: [],
        addResponse: [],
        addResponseDoc: [],
        addAttachments: [],
        dataCollectionAddDescription: [],
        dataCollectionAddAttachments: [],
        showLinksSection: false,
        showLinksSectionTwo: false,
        showQuestionLinksSection: false,
        showQuestionTwoLinksSection: false,
        referenceInvalid: false,
        selectedFrameworkControls: [],
        selectedFramework: [],
        selectedFrameworkControl: [],
        frameworkControlItems: [],
        frameworkItems: [],
        selectedLinkedControls: [],
        selectedLinkedControlsAsTarget: [],
        selectedLinkedControl: [],
        selectedAssessment: [],
        assessmentItems: [],
        assessmentControlItems: [],
        error: '',
        tableItems: [],
        tableRiskItems: [],
        loading: true,
        itemToDelete: {},
        buttonDisabled: false,

        responseTypes: [
          {
            group: this.$t('maintenance.questions.answer_type.input_label'),
            items: [
              { name: this.$t('maintenance.questions.type.datepicker'), value: 'Datepicker' },
            ]
          },
          {
            group: this.$t('maintenance.questions.answer_type.dropdown_label'),
            items: [
              { name: this.$t('maintenance.questions.type.dropdown'), value: 'Dropdown'},
              { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No'}
            ]
          }
        ],
        allowTypes: [
          { name: this.$t('maintenance.questions.type.no'), value: 'No' },
          { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
          { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' }
        ],
        allowTypesDoc: [
          { name: this.$t('maintenance.questions.type.no'), value: 'No' },
          { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
          { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
          { name: this.$t('maintenance.questions.type.auditor'), value: 'Auditor' },
        ],
        allowTypesShort: [
          { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
          { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
        ],
        answerTypes: [
          {
            group: this.$t('maintenance.questions.answer_type.positive_negative_label'),
            items: [
              { name: this.$t('maintenance.questions.answer_type.neutral'), value: 'Neutral' },
              { name: this.$t('maintenance.questions.answer_type.positive'), value: 'Positive' },
              { name: this.$t('maintenance.questions.answer_type.negative'), value: 'Negative' },
            ]
          },
          {
            group: this.$t('maintenance.questions.answer_type.impact_assessment_label'),
            items: [
              { name: this.$t('maintenance.questions.answer_type.very_low'), value: 'Very low' },
              { name: this.$t('maintenance.questions.answer_type.low'), value: 'Low' },
              { name: this.$t('maintenance.questions.answer_type.high'), value: 'High' },
              { name: this.$t('maintenance.questions.answer_type.very_high'), value: 'Very high' },
            ]
          },
        ],
        yesNoOptions: [
          'Yes',
          'No'
        ],
        yesValue: [],
        noValue: [],
        yesValueDoc: [],
        noValueDoc: [],
        dataCollectionOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0},
        ],
        selectedOptions: [],
        inputOption: '',
        positiveAnswers: [],
        negativeAnswers: [],
        selectedOptionsDoc: [],
        inputOptionDoc: '',
        positiveAnswersDoc: [],
        negativeAnswersDoc: [],
        allAnswers: [],
        allAnswersCopy: [],
        selectedQuestion: [],
        showInput: true,
        showInputDoc: true,
        showOptionInput: true,
        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        inputLinkDataCollection: '',
        inputLinkNameDataCollection: '',
        showDocuments: false,
        showAttachments: false,
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
        filteredTableItems: [],
        selectedQuestionDependency: [],
        selectedAnswers: [],
        answers: [],
        uploader: false,
        showDropActive: false,
        showDropActiveTwo: false,
        showFullGuideDescription: false,
        wpGuide: {},
        myGuides: [],
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      tasks: {
        type: Array
      },
      guides: {
        type: Array
      }
    },
    components: {
      draggable,
      GuideButton,
      ConfirmRemoveAttachment
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows;
      },
      getClient() {
        return this.$store.state.client;
      },
      getFiles() {
        return this.selectedFiles;
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf;
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf;
      },
      getQuestionMedia() {
        let media = [];

        media = _.filter(this.selectedQuestion.media, function(mediaItem) {
          return mediaItem.collection_name === 'question';
        });

        return media;
      },
      getDataCollectionMedia() {
        let media = [];

        media = _.filter(this.selectedQuestion.media, function(mediaItem) {
          return mediaItem.collection_name === 'data_collection';
        });

        return media;
      },
      getQuestionLinks() {
        let links = [];

        links = _.filter(this.selectedQuestion.links, function(link) {
          return link.collection === 'question' || link.collection == null;
        });

        return links;
      },
      getQuestionTwoLinks() {
        let links = [];

        links = _.filter(this.selectedQuestion.links, function(link) {
          return link.collection === 'question_two' || link.collection == null;
        });

        return links;
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      },
      object: function (value) {
        this.assessment = value;
      },
      selectedOptions: function (value) {
        let self = this;
        this.allAnswers = value;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        _.forEach(this.positiveAnswers, function (answer) {
          self.handleAvailableAnswers(answer);
        })
        _.forEach(this.negativeAnswers, function (answer) {
          self.handleAvailableAnswers(answer);
        })
      }
    },
    methods: {
      formatOptionLabel(option) {
        // Ensure reference and name are handled even if one is missing
        const reference = option.reference || '';
        const name = option.name || '';
        if(reference){
          return `${reference}: ${name}`;
        }else{
          return `${name}`;
        }
      },
      debounceInput: _.debounce(function() {
        let self = this;

        if (this.form.reference && this.form.reference !== '') {
          piincHttp.get('questions', { params:
            {
              per_page: 1,
              reference: this.form.reference,
              assessment: self.assessment.id,
              client: this.getClient.slug
            }
          }).then(function(response) {
            let total = response.data.total_count;
            if (total === 0) {
              self.referenceInvalid = false;
            } else {
              self.referenceInvalid = true;
            }
          }, function() {});
        } else {
          self.referenceInvalid = false;
        }

      }, 400),
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope === code && object.type === 'Maintenance' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Maintenance',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0]);
          }
        }, function() {});
      },
      showCreateControlObjectiveModal() {
        this.coForm.name = '';
        this.coForm.description = '';
        this.error = '';
        this.$refs['add-control-objective'].show();
      },
      hideCreateControlObjectiveModal() {
        this.coForm.name = '';
        this.coForm.description = '';
        this.error = '';
        this.loadCO();
        this.$refs['add-control-objective'].hide();
      },
      showConfirmDeleteCOModal(object) {
        this.error = '';
        this.itemToDelete = object;

        // this.itemToDelete = object
        this.$refs['delete-control-objective'].show();
      },
      hideConfirmDeleteCOModal() {
        this.itemToDelete = {};
        this.$refs['delete-control-objective'].hide();
      },
      confirmDeleteCO(object) {
        let self = this;
        this.buttonDisabled = true;

        if (object.questionItems && !object.questionItems.length) {
          piincHttp.delete('assessment-control-objectives/' + object.id).then(function() {
            self.hideConfirmDeleteCOModal();
            self.loadQuestions();
            self.buttonDisabled = false;
            self.$toastr('success', self.$t('maintenance.control_objective.delete.success'));
          }, function() {});
        }else{
          self.buttonDisabled = false;
          self.error = this.$t('maintenance.questions.delete.linked_assessment_controls_error');
        }
      },
      postRiskOrder() {
        let self = this;
        let order = []
        _.forEach(this.tableRiskItems, function (item, index) {
          order.push({
            id: item.id,
            position: index + 1
          });
        })
        piincHttp.post('questions/order', {
          assessment_id: this.assessment.id,
          order: order
        }).then(function(response) {
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      showAddLinkedControlModal() {
        this.assessmentLinkedControlOpen = true;
        this.selectedAssessment = [];
        this.error = '';
        this.selectedLinkedControl = [];
        this.loadAssessmentItems();
        this.$refs['add-linked-control'].show();
      },
      hideAddLinkedControlModal() {
        this.assessmentLinkedControlOpen = false;
        this.error = '';
        this.selectedAssessment = [];
        this.selectedLinkedControl = [];
        this.$refs['add-linked-control'].hide();
      },
      loadAssessmentItems(query) {
        let self = this;
        piincHttp.get('assessments', { params:
            {
              client: this.getClient.slug,
              per_page: 100,
              keyword: query ? query : undefined
            }
        }).then(function(response) {
          self.assessmentItems = response.data.items
          if (self.assessmentItems && !self.assessmentItems.length && !query) {
            self.assessmentItems.push({name: self.$t('system.no_results'), $isDisabled: true});
          }
        }, function() {});
      },
      loadAssessmentControlItems(query) {
        let self = this;

        piincHttp.get('questions', { params:
            {
              client: self.getClient.slug,
              per_page: 100,
              assessment: self.selectedAssessment.id
            }
        }).then(function(responseQuestions) {

          const globalIdToRemove = self.selectedQuestion.id;

          // Filter out questions that are already selected
          self.assessmentControlItems = responseQuestions.data.items.filter(
            question => question.id !== globalIdToRemove
          );

          if (self.assessmentControlItems && !self.assessmentControlItems.length && !query) {
            self.assessmentControlItems.push({name: self.$t('system.no_results'), $isDisabled: true});
          }
        }, function() {});
      },
      linkedControlFormSubmit(evt) {
        let self = this;
        evt.preventDefault();

        let addToArray = false;

        if (self.selectedLinkedControl && self.selectedLinkedControl.id) {
          if (this.selectedLinkedControls.length) {
            _.forEach(this.selectedLinkedControls, function (item) {
              if (item.id !== self.selectedLinkedControl.id) {
                addToArray = true;
              }
            })
          } else {
            addToArray = true;
          }

          if (addToArray) {
            this.selectedLinkedControls.push(this.selectedLinkedControl);
          }

          this.hideAddLinkedControlModal();
        } else {
          this.error = this.$t('maintenance.questions.create.framework_control_error');
        }

      },
      handleAssessmentChange(item) {
        this.selectedAssessment = item;
        this.loadAssessmentControlItems();
      },
      showAddFrameworkControlModal() {
        this.assessmentControlOpen = true;
        this.selectedFramework = [];
        this.error = '';
        this.selectedFrameworkControl = [];
        this.loadFrameworkItems();
        this.$refs['add-framework-control'].show();
      },
      hideAddFrameworkControlModal() {
        this.assessmentControlOpen = false;
        this.error = '';
        this.selectedFramework = [];
        this.selectedFrameworkControl = [];
        this.$refs['add-framework-control'].hide();
      },
      handleFrameworkChange(item) {
        this.selectedFramework = item;
        this.loadFrameworkControlItems();
      },
      loadFrameworkItems(query) {
        let self = this;
        piincHttp.get('frameworks', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.frameworkItems = response.data.items
          if (self.frameworkItems && !self.frameworkItems.length && !query) {
            self.frameworkItems.push({name: self.$t('system.no_results'), $isDisabled: true});
          }
        }, function() {});
      },
      loadFrameworkControlItems(query) {
        let self = this;
        piincHttp.get('framework-controls', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            framework: this.selectedFramework.id,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.frameworkControlItems = response.data.items;
          if (self.frameworkControlItems && !self.frameworkControlItems.length && !query) {
            self.frameworkControlItems.push({name: self.$t('system.no_results'), $isDisabled: true});
          }
        }, function() {});

        console.log(self.frameworkControlItems)
      },
      frameworkControlFormSubmit(evt) {
        let self = this;
        evt.preventDefault();

        let addToArray = false;

        if (self.selectedFrameworkControl && self.selectedFrameworkControl.id) {
          if (this.selectedFrameworkControls.length) {
            _.forEach(this.selectedFrameworkControls, function (item) {
              if (item.id !== self.selectedFrameworkControl.id) {
                addToArray = true;
              }
            })
          } else {
            addToArray = true;
          }

          if (addToArray) {
            this.selectedFrameworkControls.push(this.selectedFrameworkControl);
          }

          this.hideAddFrameworkControlModal();
        } else {
          this.error = this.$t('maintenance.questions.create.framework_control_error');
        }

      },
      handleType(value) {
        this.positiveAnswers = [];
        this.negativeAnswers = [];
        if (value && value.value === 'Dropdown' || value.value === 'System') {
          this.allAnswers = this.selectedOptions;
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        } else {
          this.noValue = this.answerTypes[0].items[0];
          this.yesValue = this.answerTypes[0].items[0];
          this.allAnswers = this.yesNoOptions;
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        }
      },
      handleTypeDoc(value) {
        this.positiveAnswersDoc = [];
        this.negativeAnswersDoc = [];
        if (value && value.value === 'Dropdown' || value.value === 'System') {
          this.allAnswers = this.selectedOptionsDoc;
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        } else {
          this.noValue = this.answerTypes[0].items[0];
          this.yesValue = this.answerTypes[0].items[0];
          this.allAnswers = this.yesNoOptions;
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        }
      },
      showDropActiveFunction(value) {
        this.showDropActive = value;
      },
      showDropActiveFunctionTwo(value) {
        this.showDropActiveTwo = value;
      },
      handleAnswers(question) {
        this.answers = [];
        let self = this;

        if (question.response_type_options) {
          let array = JSON.parse(question.response_type_options);
          _.forEach(array, function (item, index) {
            self.answers.push({
              title: item.title,
              value: item.title,
            });
          })
        }

        if (question.response_type_options_doc) {
          let array = JSON.parse(question.response_type_options_doc);
          _.forEach(array, function (item, index) {
            self.answers.push({
              title: item.title,
              value: item.title,
            });
          })
        }

      },
      handleOption(evt) {
        evt.preventDefault();
        // If there's a link in input, add it to links array
        if (this.inputOption !== '') {
          this.selectedOptions.push({title: this.inputOption, value: this.answerTypes[0].items[0]});
          // Reset link input form
          this.inputOption = '';
        }
        this.showOptionInput = false;
      },
      handleOptionDoc(evt) {
        evt.preventDefault();
        // If there's a link in input, add it to links array
        if (this.inputOptionDoc !== '') {
          this.selectedOptionsDoc.push({title: this.inputOptionDoc, value: this.answerTypes[0].items[0]});
          // Reset link input form
          this.inputOptionDoc = '';
        }
        this.showOptionInputDoc = false;
      },
      openDeleteAttachmentModal(object) {
        this.selectedFile = object;
        this.showDeleteAttachmentModal = true;
      },
      closeDeleteAttachmentModal () {
        this.selectedFile = {};
        this.showDeleteAttachmentModal = false;
        this.loadQuestion();
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object;
        this.showDeleteLinkModal = true;
      },
      closeDeleteLinkModal () {
        this.selectedLink = {};
        this.showDeleteLinkModal = false;
        this.loadQuestion();
      },
      handleEditLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'https://' + this.inputLink;
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("collection", "question");
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        piincHttp.post('links', formData).then(function() {
          self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'));
          self.loadQuestion();
          self.inputLink = '';
          self.inputLinkName = '';
          self.showInput = false;
        }, function() {})
      },
      getDataCollectionTwoLinks() {
        let links = []

        links = _.filter(this.selectedQuestion.links, function(link) {
          return link.collection === 'data_collection_two';
        });

        return links;
      },
      handleEditDataCollectionLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLinkDataCollection.startsWith('http')) {
          this.inputLinkDataCollection = 'https://' + this.inputLinkDataCollection;
        }

        formData.append("url", this.inputLinkDataCollection);
        formData.append("name", this.inputLinkNameDataCollection);
        formData.append("collection", "data_collection");
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        piincHttp.post('links', formData).then(function() {
          self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'));
          self.loadQuestion();
          self.inputLinkDataCollection = '';
          self.inputLinkNameDataCollection = '';
          self.showInput = false;
        }, function() {})
      },
      handleEditDataCollectionTwoLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLinkDataCollection.startsWith('http')) {
          this.inputLinkDataCollection = 'https://' + this.inputLinkDataCollection;
        }

        formData.append("url", this.inputLinkDataCollection);
        formData.append("name", this.inputLinkNameDataCollection);
        formData.append("collection", "data_collection_two");
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        piincHttp.post('links', formData).then(function() {
          self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'));
          self.loadQuestion();
          self.inputLinkDataCollection = '';
          self.inputLinkNameDataCollection = '';
          self.showInput = false;
        }, function() {})
      },
      onFileChangeDataCollectionTwoEdit(files) {
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        console.log('22222')
        // Append list of attachments to FormData
        for (let i = 0; i < this.data_collection_two_files.length; i++) {
          // Equal to 10 MB
          if (this.data_collection_two_files[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("document[]", this.data_collection_two_files[i].file);
        }

        formData.append("name", "documents");
        formData.append("collection", "data_collection_two");
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        if (sizeError) {
          this.error = this.$t('system.file_size_30')
          this.data_collection_files = []
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'));
            self.error = '';
            self.loadQuestion()
            // reset the model array
            self.data_collection_two_files = [];
          }, function(error) {
            self.error = error.data.message;
          })
        }
      },
      getDataCollectionLinks() {
        let links = []

        links = _.filter(this.selectedQuestion.links, function(link) {
          return link.collection === 'data_collection';
        });

        return links;
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      onFileChangeEdit() {
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        // Append list of attachments to FormData
        for (let i = 0; i < this.files.length; i++) {
          // Equal to 10 MB
          if (this.files[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("document[]", this.files[i].file);
        }
        console.log('one')

        formData.append("name", "documents");
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        if (sizeError) {
          this.error = this.$t('system.file_size_30')
          this.files = []
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'));
            self.error = '';
            self.loadQuestion();
            // reset the model array
            self.files = [];
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0];
            }
          })
        }
      },
      onFileTwoChangeEdit() {
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        console.log('two')
        // Append list of attachments to FormData
        for (let i = 0; i < this.files_two.length; i++) {
          // Equal to 10 MB
          if (this.files_two[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("document[]", this.files_two[i].file);
        }

        formData.append("name", "documents");
        formData.append("collection", "question_two");
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        if (sizeError) {
          this.error = this.$t('system.file_size_30')
          this.files = []
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'));
            self.error = '';
            self.loadQuestion();
            // reset the model array
            self.files = [];
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0];
            }
          })
        }
      },
      onFileChangeDataCollectionEdit(files) {
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        console.log('1111111');
        // Append list of attachments to FormData
        for (let i = 0; i < this.data_collection_files.length; i++) {
          // Equal to 10 MB
          if (this.data_collection_files[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("document[]", this.data_collection_files[i].file);
        }

        formData.append("name", "documents");
        formData.append("collection", "data_collection");
        formData.append("model_type", this.selectedQuestion.who_am_i);
        formData.append("model_id", this.selectedQuestion.id);

        if (sizeError) {
          this.error = this.$t('system.file_size_30')
          this.data_collection_files = []
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'));
            self.error = '';
            self.loadQuestion()
            // reset the model array
            self.data_collection_files = [];
          }, function(error) {
            self.error = error.data.message;
          })
        }
      },
      removeOptionItem(index, item) {
        let positiveIndex = _.findIndex(this.positiveAnswers, function(answer) { return answer === item });
        let negativeIndex = _.findIndex(this.negativeAnswers, function(answer) { return answer === item });

        this.selectedOptions.splice(index, 1);

        if (!this.selectedOptions.length) {
          this.showOptionInput = true;
        }

        if (positiveIndex !== -1) {
          this.positiveAnswers.splice(positiveIndex, 1);
        }
        if (negativeIndex !== -1) {
          this.negativeAnswers.splice(negativeIndex, 1);
        }
      },
      emoveOptionItemDoc(index, item) {
        let positiveIndex = _.findIndex(this.positiveAnswersDoc, function(answer) { return answer === item });
        let negativeIndex = _.findIndex(this.negativeAnswersDoc, function(answer) { return answer === item });

        this.selectedOptionsDoc.splice(index, 1);

        if (!this.selectedOptionsDoc.length) {
          this.showOptionInputDoc = true;
        }

        if (positiveIndex !== -1) {
          this.positiveAnswersDoc.splice(positiveIndex, 1);
        }
        if (negativeIndex !== -1) {
          this.negativeAnswersDoc.splice(negativeIndex, 1);
        }
      },
      handleAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer === item });
        if (index !== -1) {
          this.allAnswersCopy.splice(index, 1);
        }
      },
      expandAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer === item });
        if (index === -1) {
          this.allAnswersCopy.push(answer);
        }
      },
      // Create modals
      showCreateQForm() {
        this.buttonDisabled = true;
        let self = this;
        this.error = '';
        this.selectedOptions = [];
        this.inputOption = '';
        this.positiveAnswers = [];
        this.negativeAnswers = [];
        this.selectedOptionsDoc = [];
        this.inputOptionDoc = '';
        this.positiveAnswersDoc = [];
        this.negativeAnswersDoc = [];
        this.selectedControlObjective = [];
        this.allAnswers = [];
        this.responseType = [];
        this.responseTypeDoc = [];
        this.selectedFiles = [];
        this.selectedFrameworkControls = [];
        this.selectedLinkedControls = [];
        this.form.links = [];
        this.inputLink = '';
        this.inputLinkName = '';
        this.inputLinkDataCollection = '';
        this.inputLinkNameDataCollection = '';
        this.data_collection_on = 0;
        this.showInput = true;
        this.showInputDoc = true;
        this.showOptionInput = true;
        this.referenceInvalid = false;

        this.form.name = '';
        this.form.description = '';
        this.form.description_two = '';
        this.form.data_collection_description = '';
        this.form.data_collection_description_two = '';
        this.form.reference = '';
        this.form.control_description_default_text = '';
        this.form.testing_notes_default_text = '';
        this.form.performed_test_default_text = '';
        this.form.conclusion_default_text = '';

        this.form.links = [];
        this.form.data_collection_links = [];

        this.files = [];
        this.data_collection_files = [];
        this.addDescription = this.allowTypes[1];
        this.addResponse = this.allowTypes[1];
        this.addResponseDoc = this.allowTypes[1];
        this.addControlDescription = this.allowTypes[1];
        this.addNotes = this.allowTypes[1];
        this.addTestingNotes = this.allowTypes[1];
        this.addPerformedText = this.allowTypes[1];
        this.addAttachments = this.allowTypes[1];
        this.dataCollectionAddDescription = this.allowTypes[1];
        this.dataCollectionAddAttachments = this.allowTypes[1];
        this.showLinksSection = false;
        this.showLinksSectionTwo = false;
        this.showQuestionLinksSection = false;
        this.showQuestionTwoLinksSection = false;
        if(self.assessment.type == 'control'){
          this.loadCO();
        }


        this.selectedQuestionDependency = [];
        this.selectedAnswers = [];
        self.$refs['add-question-1'].show();
        self.$refs['add-question-2'].hide();
        self.$refs['add-question-3'].hide();
        self.$refs['add-question-4'].hide();
        self.$refs['add-question-5'].hide();
        self.buttonDisabled = false;
      },
      showCreateQForm1() {
        this.buttonDisabled = true;
        let self = this;
        self.$refs['add-question-1'].show();
        self.$refs['add-question-2'].hide();
        self.$refs['add-question-3'].hide();
        self.$refs['add-question-4'].hide();
        self.$refs['add-question-5'].hide();
        self.buttonDisabled = false;
      },
      showCreateQForm2(type) {
        this.buttonDisabled = true;
        let self = this;
        self.error = '';
        let controlvalidation = false;
        if (type && type === 'forward') {
          if(this.assessment.type == 'control' && this.selectedControlObjective && this.selectedControlObjective.id){
            controlvalidation = true;
          }else if(this.assessment.type == 'risk'){
            controlvalidation = true;
          }
          if (self.form.name && self.form.name.length && controlvalidation) {
            self.$refs['add-question-1'].hide();
            self.$refs['add-question-2'].show();
            self.$refs['add-question-3'].hide();
            self.$refs['add-question-4'].hide();
            self.$refs['add-question-5'].hide();
          } else {
            self.error = '';
            if (!self.form.name.length) {
              this.error += ' ' + this.$t('maintenance.data_objects.create.name_error');
            }
            if (!this.selectedControlObjective || (this.selectedControlObjective && !this.selectedControlObjective.id)) {
              this.error += ' ' + this.$t('maintenance.questions.create.control_objective_error_message');
            }

          }
        } else {
          self.$refs['add-question-1'].hide();
          self.$refs['add-question-2'].show();
          self.$refs['add-question-3'].hide();
          self.$refs['add-question-4'].hide();
          self.$refs['add-question-5'].hide();
        }

        self.buttonDisabled = false;
      },
      showCreateQForm3(type) {
        this.buttonDisabled = true;
        let self = this;
        self.error = '';
        let controlvalidation = false;


          self.$refs['add-question-1'].hide();
          self.$refs['add-question-2'].hide();
          self.$refs['add-question-3'].show();
          self.$refs['add-question-4'].hide();
          self.$refs['add-question-5'].hide();


        self.buttonDisabled = false;
      },
      showCreateQForm4(type) {
        this.buttonDisabled = true;
        let self = this;
        self.error = '';


        self.$refs['add-question-1'].hide();
        self.$refs['add-question-2'].hide();
        self.$refs['add-question-3'].hide();
        self.$refs['add-question-4'].show();
        self.$refs['add-question-5'].hide();

        self.buttonDisabled = false;
      },
      showCreateQForm5(type) {
        this.buttonDisabled = true;
        let self = this;
        let sizeError = false;
        self.error = '';

        if (type && type === 'forward') {

          for (let i = 0; i < this.data_collection_files.length; i++) {
            // Equal to 10 MB
            if (this.data_collection_files[i].size > 31457280) {
              sizeError = true;
            }
          }

          if ((self.data_collection_on && self.form.data_collection_description.length && this.dataCollectionAddAttachments && this.dataCollectionAddDescription.value && this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value && !sizeError) || !self.data_collection_on) {
            self.$refs['add-question-1'].hide();
            self.$refs['add-question-2'].hide();
            self.$refs['add-question-3'].hide();
            self.$refs['add-question-4'].hide();
            self.$refs['add-question-5'].show();
          } else {
            self.error = ''
            if (!self.form.data_collection_description.length) {
              this.error += ' ' + this.$t('maintenance.questions.create.data_collection_description_error_message');
            }
            if (sizeError) {
              this.error += ' ' + this.$t('system.file_size_30');
            }
            if (!this.dataCollectionAddDescription || (this.dataCollectionAddDescription && !this.dataCollectionAddDescription.value)) {
              this.error += ' ' + this.$t('maintenance.questions.create.add_description_error_message');
            }
            if (!this.dataCollectionAddAttachments || (this.dataCollectionAddAttachments && !this.dataCollectionAddAttachments.value)) {
              this.error += ' ' + this.$t('maintenance.questions.create.add_attachments_error_message');
            }
          }
        } else {
          self.$refs['add-question-1'].hide();
          self.$refs['add-question-2'].hide();
          self.$refs['add-question-3'].hide();
          self.$refs['add-question-4'].hide();
          self.$refs['add-question-5'].show();
        }

        self.buttonDisabled = false;
      },

      hideCreateQModal() {
        this.$refs['add-question-1'].hide();
        this.$refs['add-question-2'].hide();
        this.$refs['add-question-3'].hide();
        this.$refs['add-question-4'].hide();
        this.$refs['add-question-5'].hide();
      },
      // Edit modals
      showEditQForm1() {
        this.buttonDisabled = true;
        let self = this;
        self.$refs['edit-question-1'].show();
        self.$refs['edit-question-2'].hide();
        self.$refs['edit-question-3'].hide();
        self.$refs['edit-question-4'].hide();
        self.$refs['edit-question-5'].hide();
        self.buttonDisabled = false;
      },
      // Edit modals
      showEditQForm2(type) {
        this.buttonDisabled = true;
        let self = this;
        self.error = '';
        let controlvalidation = false;
        if (type && type == 'forward') {

          if(this.assessment.type == 'control' && this.selectedControlObjective && this.selectedControlObjective.id){
            controlvalidation = true;
          }else if(this.assessment.type == 'risk'){
            controlvalidation = true;
          }
          if (self.form.name && self.form.name.length && controlvalidation && !this.referenceInvalid) {
            self.$refs['edit-question-1'].hide();
            self.$refs['edit-question-2'].show();
            self.$refs['edit-question-3'].hide();
            self.$refs['edit-question-4'].hide();
            self.$refs['edit-question-5'].hide();
          } else {
            self.error = ''
            if (!self.form.name.length) {
              this.error += ' ' + this.$t('maintenance.data_objects.create.name_error');
            }
            if (self.referenceInvalid) {
              this.error += ' ' + this.$t('maintenance.questions.create.reference_error_message');
            }
            if (!this.selectedControlObjective || (this.selectedControlObjective && !this.selectedControlObjective.id)) {
              this.error += ' ' + this.$t('maintenance.questions.create.control_objective_error_message');
            }
          }
        } else {
          self.$refs['edit-question-1'].hide();
          self.$refs['edit-question-2'].show();
          self.$refs['edit-question-3'].hide();
          self.$refs['edit-question-4'].hide();
          self.$refs['edit-question-5'].hide();
        }

        self.buttonDisabled = false;
      },
      showEditQForm3(type) {
        this.buttonDisabled = true;
        let self = this;
        self.error = '';
        let controlvalidation = false;
        if (type && type == 'forward') {


            self.$refs['edit-question-1'].hide();
            self.$refs['edit-question-2'].hide();
            self.$refs['edit-question-3'].show();
            self.$refs['edit-question-4'].hide();
            self.$refs['edit-question-5'].hide();

        } else {
          self.$refs['edit-question-1'].hide();
          self.$refs['edit-question-2'].hide();
          self.$refs['edit-question-3'].show();
          self.$refs['edit-question-4'].hide();
          self.$refs['edit-question-5'].hide();
        }

        self.buttonDisabled = false;
      },
      showEditQForm4() {
        this.buttonDisabled = true;
        let self = this;
        self.error = '';

        self.$refs['edit-question-1'].hide();
        self.$refs['edit-question-2'].hide();
        self.$refs['edit-question-3'].hide();
        self.$refs['edit-question-4'].show();
        self.$refs['edit-question-5'].hide();

        self.buttonDisabled = false;
      },
      showEditQForm5(type) {
        this.buttonDisabled = true;
        let self = this;
        self.error = '';

        if (type && type === 'forward') {

          if ((self.data_collection_on && self.form.data_collection_description && self.form.data_collection_description.length && this.dataCollectionAddAttachments && this.dataCollectionAddDescription.value && this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value) || !self.data_collection_on) {
            self.$refs['edit-question-1'].hide();
            self.$refs['edit-question-2'].hide();
            self.$refs['edit-question-3'].hide();
            self.$refs['edit-question-4'].hide();
            self.$refs['edit-question-5'].show();
          } else {
            self.error = ''
            if (!self.form.data_collection_description.length) {
              this.error += ' ' + this.$t('maintenance.questions.create.data_collection_description_error_message');
            }
            if (!this.dataCollectionAddDescription || (this.dataCollectionAddDescription && !this.dataCollectionAddDescription.value)) {
              this.error += ' ' + this.$t('maintenance.questions.create.add_description_error_message');
            }
            if (!this.dataCollectionAddAttachments || (this.dataCollectionAddAttachments && !this.dataCollectionAddAttachments.value)) {
              this.error += ' ' + this.$t('maintenance.questions.create.add_attachments_error_message');
            }
          }
        } else {
          self.$refs['edit-question-1'].hide();
          self.$refs['edit-question-2'].hide();
          self.$refs['edit-question-3'].hide();
          self.$refs['edit-question-4'].hide();
          self.$refs['edit-question-5'].show();
        }

        self.buttonDisabled = false;
      },

      hideEditQModal() {
        this.assessmentControlOpen = false;
        this.$refs['edit-question-1'].hide();
        this.$refs['edit-question-2'].hide();
        this.$refs['edit-question-3'].hide();
        this.$refs['edit-question-4'].hide();
        this.$refs['edit-question-5'].hide();
      },
      lockSwitch(lockStatus) {
        if (lockStatus) {
          this.data_collection_on = 0;
        }else{
          this.data_collection_on = 1;
        }
      },
      showEditQModal(object) {
        let self = this;

        if(self.assessment.type == 'control'){
          this.loadCO();
        }

        this.error = '';
        this.selectedOptions = [];
        this.inputOption = '';
        this.positiveAnswers = [];
        this.negativeAnswers = [];
        this.selectedOptionsDoc = [];
        this.inputOptionDoc = '';
        this.positiveAnswersDoc = [];
        this.negativeAnswersDoc = [];
        this.allAnswers = [];
        this.selectedControlObjective = [];
        this.selectedLinkedControls = [];
        this.selectedLinkedControlsAsTarget = [];
        this.responseType = [];
        this.responseTypeDoc = [];
        this.selectedFiles = [];
        this.selectedFrameworkControls = [];
        this.form.links = [];
        this.inputLink = '';
        this.inputLinkName = '';
        this.inputLinkDataCollection = '';
        this.inputLinkNameDataCollection = '';
        this.data_collection_on = 0;
        this.showInput = true;
        this.showInputDoc = true;
        this.showOptionInput = true;
        this.referenceInvalid = false;

        this.form.name = '';
        this.form.description = '';
        this.form.description_two = '';
        this.form.data_collection_description = '';
        this.form.data_collection_description_two = '';
        this.form.reference = '';

        this.form.links = [];
        this.form.data_collection_links = [];

        this.files = [];
        this.data_collection_files = [];
        this.addDescription = [];
        this.addResponse = [];
        this.addResponseDoc = [];
        this.addControlDescription = [];
        this.addNotes = [];
        this.addTestingNotes = [];
        this.addPerformedText = [];
        this.addAttachments = [];
        this.dataCollectionAddDescription = [];
        this.dataCollectionAddAttachments = [];
        this.showLinksSection = false;
        this.showQuestionLinksSection = false;
        this.showQuestionTwoLinksSection = false;
        this.selectedQuestionDependency = [];
        this.selectedAnswers = [];

        this.selectedQuestion = object;

        this.dependantQuestionItems = [];
        _.forEach(self.filteredTableItems, function (question) {
          if (question.id !== self.selectedQuestion.id) {
            self.dependantQuestionItems.push(question);
          }
        })

        if (object.framework_controls && object.framework_controls.length) {
          this.selectedFrameworkControls = _.cloneDeep(object.framework_controls);
        }

        this.selectedLinkedControls = [...object.linked_controls];
        this.selectedLinkedControlsAsTarget = [...object.linkedControlsAsTarget];

        console.log(this.selectedLinkedControls)
        console.log(this.selectedLinkedControlsAsTarget)
        this.responseType = [];
        if (object.response_type) {
          if (object.response_type === 'Datepicker') {
            this.responseType = _.find(this.responseTypes[0].items, function(item) {
              return item.value === object.response_type;
            });
          } else {
            this.responseType = _.find(this.responseTypes[1].items, function(item) {
              return item.value === object.response_type;
            });
          }
        }

        this.responseTypeDoc = [];
        if (object.response_type_doc) {
          if (object.response_type_doc === 'Datepicker') {
            this.responseTypeDoc = _.find(this.responseTypes[0].items, function(item) {
              return item.value === object.response_type_doc;
            });
          } else {
            this.responseTypeDoc = _.find(this.responseTypes[1].items, function(item) {
              return item.value === object.response_type_doc;
            });
          }
        }


        this.addDescription = [];
        if (object.add_description) {
          this.addDescription = _.find(this.allowTypes, function(item) {
            return item.value === object.add_description;
          });
        }

        this.addResponse = [];
        if (object.add_response) {
          this.addResponse = _.find(this.allowTypes, function(item) {
            return item.value === object.add_response;
          });
        }

        this.addResponseDoc = [];
        if (object.add_response_doc) {
          this.addResponseDoc = _.find(this.allowTypesDoc, function(item) {
            return item.value === object.add_response_doc;
          });
        }

        this.addNotes = [];
        if (object.add_control_description) {
          this.addNotes = _.find(this.allowTypes, function(item) {
            return item.value === object.add_notes;
          });
        }

        this.addTestingNotes = [];
        if (object.add_testing_notes) {
          this.addTestingNotes = _.find(this.allowTypes, function(item) {
            return item.value === object.add_testing_notes;
          });
        }

        this.addControlDescription = [];
        if (object.add_control_description) {
          this.addControlDescription = _.find(this.allowTypes, function(item) {
            return item.value === object.add_control_description;
          });
        }

        this.addPerformedText = [];
        if (object.add_performed_text) {
          this.addPerformedText = _.find(this.allowTypes, function(item) {
            return item.value === object.add_performed_text;
          });
        }

        this.form.control_description_default_text = '';
        if (object.control_description_default_text) {
          this.form.control_description_default_text = object.control_description_default_text;
        }
        this.form.testing_notes_default_text = '';
        if (object.testing_notes_default_text) {
          this.form.testing_notes_default_text = object.testing_notes_default_text;
        }
        this.form.performed_test_default_text = '';
        if (object.performed_test_default_text) {
          this.form.performed_test_default_text = object.performed_test_default_text;
        }

        this.form.conclusion_default_text = '';
        if (object.conclusion_default_text) {
          this.form.conclusion_default_text = object.conclusion_default_text;
        }

        this.addAttachments = [];
        if (object.add_attachments) {
          this.addAttachments = _.find(this.allowTypes, function(item) {
            return item.value === object.add_attachments;
          });
        }

        this.dataCollectionAddDescription = [];
        if (object.data_collection_add_description) {
          this.dataCollectionAddDescription = _.find(this.allowTypes, function(item) {
            return item.value === object.data_collection_add_description;
          });
        } else {
          this.dataCollectionAddDescription = this.allowTypes[1];
        }

        this.dataCollectionAddAttachments = [];
        if (object.data_collection_add_attachments) {
          this.dataCollectionAddAttachments = _.find(this.allowTypes, function(item) {
            return item.value === object.data_collection_add_attachments;
          });
        } else {
          this.dataCollectionAddAttachments = this.allowTypes[1];
        }

        if (this.selectedQuestion.response_type === 'Dropdown') {
          this.selectedOptions = []
          if (this.selectedQuestion.response_type_options) {
            let array = JSON.parse(this.selectedQuestion.response_type_options);
            this.selectedOptions.push(...array);
          }
        }

        if (this.selectedQuestion.response_type === 'Yes/No') {
          this.yesValue = []
          this.noValue = []
          if (this.selectedQuestion.response_type_options) {
            let array = JSON.parse(this.selectedQuestion.response_type_options);
            if(array[0]){
              this.yesValue = array[0].value;
            }
            if(array[1]){
              this.noValue = array[1].value;
            }

          }
        }

        if (this.selectedQuestion.response_type_doc === 'Dropdown') {
          this.selectedOptionsDoc = []
          if (this.selectedQuestion.response_type_options_doc) {
            let array = JSON.parse(this.selectedQuestion.response_type_options_doc);
            this.selectedOptionsDoc.push(...array);
          }
        }

        if (this.selectedQuestion.response_type_doc === 'Yes/No') {
          this.yesValueDoc = []
          this.noValueDoc = []
          if (this.selectedQuestion.response_type_options_doc) {
            let array = JSON.parse(this.selectedQuestion.response_type_options_doc);
            if(array[0]){
              this.yesValueDoc = array[0].value;
            }
            if(array[1]){
              this.noValueDoc = array[1].value;
            }

          }
        }

        this.selectedQuestionDependency = [];
        if (object.dependency_question_id) {

          this.selectedQuestionDependency = _.find(this.tableItems, function(item) {
            return item.id === object.dependency_question_id;
          });

          this.handleAnswers(this.selectedQuestionDependency);

          if (object.dependency_question_answer) {
            _.forEach(object.dependency_question_answer, function (item) {
              self.selectedAnswers.push({
                title: item,
                value: item,
              });
            })
          }
        }

        if (object.control_objective && object.control_objective.id) {
          this.selectedControlObjective = object.control_objective;
        }

        this.form.slug = object.slug;
        this.form.name = object.name;
        this.form.description = object.description;
        this.form.description_two = object.description_two;
        this.form.data_collection_description = object.data_collection_description ? object.data_collection_description : '';
        this.form.data_collection_description_two = object.data_collection_description_two ? object.data_collection_description_two : '';
        this.form.reference = object.reference;
        this.data_collection_on = object.data_collection_on;
        this.showEditQForm1();
      },
      postOrder() {
        let self = this;
        let order = [];
        _.forEach(this.tableItems, function (item, index) {
          order.push({
            id: item.id,
            position: index + 1
          });
        })
        piincHttp.post('assessment-control-objectives/order', {
          assessment_id: this.assessment.id,
          order: order
        }).then(function(response) {
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      postOrderQuestions(event, object) {
        let self = this;
        let order = []
        _.forEach(object.questionItems, function (item, index) {
          order.push({
            id: item.id,
            position: index + 1
          });

          if (item.control_objective && item.control_objective.id && item.control_objective.id !== object.id) {
            piincHttp.put('questions/' + item.slug, {
              control_objective_id: object.id,
            }).then(function(response) {
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
              }
            })
          }
        })


        piincHttp.post('questions/order', {
          assessment_id: this.assessment.id,
          control_objective_id: object.id,
          order: order
        }).then(function(response) {
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      showQConfirmDeleteModal(object) {
        this.itemToDelete = object;
        this.$refs['delete-question'].show();
      },
      hideQConfirmDeleteModal() {
        this.itemToDelete = {};
        this.$refs['delete-question'].hide();
      },
      confirmDeleteQ(object) {
        let self = this;
        piincHttp.delete('questions/' + object.slug).then(function() {
          self.hideQConfirmDeleteModal();

          if(self.assessment.type === 'control'){
            self.loadQuestions();
          }else{
            self.loadRiskQuestions();
          }
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.questions.delete.success'))
        }, function() {});
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        let sizeError = false;

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.handleLink();
        this.handleDataCollectionLink();

        formData.append("assessment_id", this.assessment.id);
        formData.append("name", this.form.name);
        formData.append("reference", this.form.reference);
        formData.append("description", this.form.description);
        formData.append("description_two", this.form.description_two);
        formData.append("control_description_default_text", this.form.control_description_default_text);
        formData.append("testing_notes_default_text", this.form.testing_notes_default_text);
        formData.append("conclusion_default_text", this.form.conclusion_default_text);
        formData.append("performed_test_default_text", this.form.performed_test_default_text);

        // Data collection formData
        if (this.data_collection_on) {

          formData.append("data_collection_on", this.data_collection_on);
          formData.append("data_collection_description", this.form.data_collection_description);
          formData.append("data_collection_description_two", this.form.data_collection_description_two);

          if (this.dataCollectionAddDescription && this.dataCollectionAddDescription.value) {
            formData.append("data_collection_add_description", this.dataCollectionAddDescription.value);
          }

          if (this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value) {
            formData.append("data_collection_add_attachments", this.dataCollectionAddAttachments.value);
          }

          // Append list of links to FormData
          for (let i = 0; i < this.form.data_collection_links.length; i++) {
            formData.append("data_collection_links[]", JSON.stringify(this.form.data_collection_links[i]));
          }

          // Append list of attachments to FormData
          for (let i = 0; i < this.data_collection_files.length; i++) {
            // Equal to 10 MB
            if (this.data_collection_files[i].size > 31457280) {
              sizeError = true;
            }
            formData.append("data_collection_files[]", this.data_collection_files[i].file);
          }

          // Append list of attachments to FormData
          for (let i = 0; i < this.data_collection_two_files.length; i++) {
            // Equal to 10 MB
            if (this.data_collection_two_files[i].size > 31457280) {
              sizeError = true;
            }
            formData.append("data_collection_two_files[]", this.data_collection_two_files[i].file);
          }

        } else {
          formData.append("data_collection_on", 0);
        }

        // Append list of attachments to FormData
        for (let i = 0; i < this.files.length; i++) {
          // Equal to 10 MB
          if (this.files[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("files[]", this.files[i].file);
        }

        // Append list of attachments to FormData
        for (let i = 0; i < this.files_two.length; i++) {
          // Equal to 10 MB
          if (this.files_two[i].size > 31457280) {
            sizeError = true;
          }
          formData.append("files_two[]", this.files_two[i].file);
        }


        // Append list of links to FormData
        for (let i = 0; i < this.form.links.length; i++) {
          formData.append("links_two[]", JSON.stringify(this.form.links[i]));
        }

        // Append list of links to FormData
        for (let i = 0; i < this.form.links.length; i++) {
          formData.append("links_two[]", JSON.stringify(this.form.links[i]));
        }

        for (let i = 0; i < this.selectedFrameworkControls.length; i++) {
          formData.append("framework_controls[]", this.selectedFrameworkControls[i].id);
        }

        for (let i = 0; i < this.selectedLinkedControls.length; i++) {
          formData.append("linked_controls[]", this.selectedLinkedControls[i].id);
        }

        if (this.responseType && this.responseType.value) {
          formData.append("response_type", this.responseType.value);
        }

        if (this.responseTypeDoc && this.responseTypeDoc.value) {
          formData.append("response_type_doc", this.responseTypeDoc.value);
        }

        if (this.selectedControlObjective && this.selectedControlObjective.id) {
          formData.append("control_objective_id", this.selectedControlObjective.id);
        }

        if (this.addDescription && this.addDescription.value) {
          formData.append("add_description", this.addDescription.value);
        }
        if (this.addResponse && this.addResponse.value) {
          formData.append("add_response", this.addResponse.value);
        }
        if (this.addResponseDoc && this.addResponseDoc.value) {
          formData.append("add_response_doc", this.addResponseDoc.value);
        }
        if (this.addControlDescription && this.addControlDescription.value) {
          formData.append("add_control_description", this.addControlDescription.value);
        }
        if (this.addNotes && this.addNotes.value) {
          formData.append("add_notes", this.addNotes.value);
        }
        if (this.addTestingNotes && this.addTestingNotes.value) {
          formData.append("add_testing_notes", this.addTestingNotes.value);
        }
        if (this.addPerformedText && this.addPerformedText.value) {
          formData.append("add_performed_text", this.addPerformedText.value);
        }

        if (this.addAttachments && this.addAttachments.value) {
          formData.append("add_attachments", this.addAttachments.value);
        }

        if (this.responseType && this.responseType.value && this.responseType.value === 'Yes/No') {
          let array = [
            {title: 'Yes', value: this.yesValue},
            {title: 'No', value: this.noValue},
          ]
          formData.append("response_type_options", JSON.stringify(array));
        }

        if (this.responseType && this.responseType.value && this.responseType.value === 'Dropdown') {
          if (this.selectedOptions && this.selectedOptions.length) {
            formData.append("response_type_options", JSON.stringify(this.selectedOptions));
          }
        }


        if (this.responseTypeDoc && this.responseTypeDoc.value && this.responseTypeDoc.value === 'Yes/No') {
          let array = [
            {title: 'Yes', value: this.yesValueDoc},
            {title: 'No', value: this.noValueDoc},
          ]


          formData.append("response_type_options_doc", JSON.stringify(array));
        }



        if (this.responseTypeDoc && this.responseTypeDoc.value && this.responseTypeDoc.value === 'Dropdown') {
          if (this.selectedOptionsDoc && this.selectedOptionsDoc.length) {
            formData.append("response_type_options_doc", JSON.stringify(this.selectedOptionsDoc));
          }
        }

        if (this.selectedQuestionDependency && this.selectedQuestionDependency.id) {
          formData.append("dependency_question_id", this.selectedQuestionDependency.id);
          for (let i = 0; i < this.selectedAnswers.length; i++) {
            formData.append("dependency_question_answer[]", this.selectedAnswers[i].title);
          }
        } else {
          formData.append("dependency_question_id", '');
        }
        if (sizeError) {
          this.error = this.$t('system.file_size_30');
          this.buttonDisabled = false;
        } else {
          this.buttonDisabled = true;

          if (((this.responseType && this.responseType.value) || (this.addResponse && this.addResponse.value === 'No')) && this.form.description.length && this.addDescription && this.addDescription.value && this.addResponse && this.addResponse.value && this.addControlDescription && this.addControlDescription.value && this.addNotes && this.addNotes.value && this.addPerformedText && this.addPerformedText.value && this.addAttachments && this.addAttachments.value && ((this.addResponse && this.addResponse.value === 'No') || (this.responseType && (this.responseType.value === 'Datepicker' || this.responseType.value === 'Yes/No')) || (this.responseType && this.responseType.value === 'Dropdown' && this.selectedOptions && this.selectedOptions.length))) {
            piincHttp.post('questions', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function() {
              self.$toastr('success', self.$t('maintenance.questions.create.success'));
              self.hideCreateQModal();

              if(self.assessment.type === 'control'){
                self.loadQuestions();
              }else{
                self.loadRiskQuestions();
              }
              self.$emit('updated');
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
              }
            })
          } else {
            this.error = '';
            self.buttonDisabled = false;
            if (!this.responseType || (this.responseType && !this.responseType.value)) {
              this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message');
            }
            if (!this.addDescription || (this.addDescription && !this.addDescription.value)) {
              this.error += this.$t('maintenance.questions.create.add_description_error_message');
            }
            if (!this.addResponse || (this.addResponse && !this.addResponse.value)) {
              this.error += this.$t('maintenance.questions.create.add_response_error_message');
            }
            if (!this.addAttachments || (this.addAttachments && !this.addAttachments.value)) {
              this.error += this.$t('maintenance.questions.create.add_attachments_error_message');
            }
            if ((this.responseType && this.responseType.value === 'Select') && this.selectedOptions && !this.selectedOptions.length) {
              this.error += this.$t('maintenance.questions.create.selected_options_error_message');
            }
          }
        }

      },
      coFormSubmit(evt) {
        this.buttonDisabled = true;
        // let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.coForm.client = this.getClient.slug;
        this.coForm.assessment_id = this.assessment.id;

        piincHttp.post('/assessment-control-objectives', this.coForm).then(function(response) {
          self.hideCreateControlObjectiveModal();
          self.loadQuestions();

          self.selectedControlObjective = response.data;

          self.$emit('updated');
          self.buttonDisabled = false;

          self.$toastr('success', self.$t('maintenance.control_objective.create.success'));
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      showEditCOModal(object) {
        this.coForm.slug = object.slug;
        this.coForm.id = object.id;
        this.coForm.name = object.name;
        this.coForm.description = object.description;
        this.$refs['edit-control-objective'].show();
      },
      hideEditCOModal() {
        this.$refs['edit-control-objective'].hide();
      },
      editCOFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.coForm.client = this.getClient.slug;
        this.coForm.assessment_id = this.assessment.id;

        if (this.coForm.name && this.coForm.name.length) {
          piincHttp.put('assessment-control-objectives/' + this.coForm.id, this.coForm).then(function(response) {
            self.hideEditCOModal();
            self.loadQuestions();
            self.$emit('updated');
            self.buttonDisabled = false;

            self.$toastr('success', self.$t('maintenance.control_objective.update.success'));
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = '';
          if (this.coForm.name === '') {
            this.error +=  ' ' + this.$t('maintenance.incidents.incident_categories.create.name_error');
          }
        }
      },
      resetFile() {
        let imagefile = document.querySelector('#file-rr');
        imagefile.value = '';
      },
      resetFileEdit() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file-rr');
        // in order for v-for to re-render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (let i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i]);
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'https://' + this.inputLink;
          }
          this.form.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = '';
          this.inputLinkName = '';
        }
      },
      handleDataCollectionLink() {
        // If there's a link in input, add it to links array
        if (this.inputLinkDataCollection !== '') {
          if (!this.inputLinkDataCollection.startsWith('http')) {
            this.inputLinkDataCollection = 'https://' + this.inputLinkDataCollection;
          }
          this.form.data_collection_links.push({url: this.inputLinkDataCollection, name: this.inputLinkNameDataCollection});
          // Reset link input form
          this.inputLinkDataCollection = '';
          this.inputLinkNameDataCollection = '';
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.form.links.splice(index, 1);
      },
      removeDataLinkItem(index) {
        // Remove link item from the links array
        this.form.data_collection_links.splice(index, 1);
      },
      removeMediaItem(index) {
        // Remove link item from the links array
        this.files.splice(index, 1);
      },
      removeDataMediaItem(index) {
        // Remove link item from the links array
        this.data_collection_files.splice(index, 1);
      },
      removeFrameworkControlItem(index) {
        // Remove link item from the links array
        this.selectedFrameworkControls.splice(index, 1);
      },
      removeLinkedControlItem(index) {
        // Remove link item from the links array
        this.selectedLinkedControls.splice(index, 1);
      },
      editFormSubmit(evt) {
        this.buttonDisabled = true;

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        let form = {};

        form.name = this.form.name;
        form.reference = this.form.reference;
        form.description = this.form.description;
        form.description_two = this.form.description_two;
        form.control_description_default_text = this.form.control_description_default_text;
        form.testing_notes_default_text = this.form.testing_notes_default_text;
        form.conclusion_default_text = this.form.conclusion_default_text;
        form.performed_test_default_text = this.form.performed_test_default_text;

        // Data collection formData
        if (this.data_collection_on) {

          form.data_collection_on = this.data_collection_on;
          form.data_collection_description = this.form.data_collection_description;
          form.data_collection_description_two = this.form.data_collection_description_two;
          if (this.dataCollectionAddDescription && this.dataCollectionAddDescription.value) {
            form.data_collection_add_description = this.dataCollectionAddDescription.value;
          }

          if (this.dataCollectionAddAttachments && this.dataCollectionAddAttachments.value) {
            form.data_collection_add_attachments = this.dataCollectionAddAttachments.value;
          }

        } else {
          form.data_collection_on = 0;
        }

        if (this.responseType && this.responseType.value) {
          form.response_type = this.responseType.value;
        }

        if (this.responseTypeDoc && this.responseTypeDoc.value) {
          form.response_type_doc = this.responseTypeDoc.value;
        }

        if (this.addDescription && this.addDescription.value) {
          form.add_description = this.addDescription.value;
        }
        if (this.addResponse && this.addResponse.value) {
          form.add_response = this.addResponse.value;
        }
        if (this.addResponseDoc && this.addResponseDoc.value) {
          form.add_response_doc = this.addResponseDoc.value;
        }
        if (this.addControlDescription && this.addControlDescription.value) {
          form.add_control_description = this.addControlDescription.value;
        }
        if (this.addNotes && this.addNotes.value) {
          form.add_notes = this.addNotes.value;
        }
        if (this.addTestingNotes && this.addTestingNotes.value) {
          form.add_testing_notes = this.addTestingNotes.value;
        }
        if (this.addPerformedText && this.addPerformedText.value) {
          form.add_performed_text = this.addPerformedText.value;
        }

        if (this.selectedControlObjective && this.selectedControlObjective.id) {
          form.control_objective_id = this.selectedControlObjective.id;
        }

        if (this.addAttachments && this.addAttachments.value) {
          form.add_attachments = this.addAttachments.value;
        }

        if (this.responseType && this.responseType.value && this.responseType.value === 'Yes/No') {
          let array = [
            {title: 'Yes', value: this.yesValue},
            {title: 'No', value: this.noValue},
          ]
          form.response_type_options = JSON.stringify(array);
        }

        if (this.responseType && this.responseType.value && this.responseType.value === 'Dropdown') {
          if (this.selectedOptions && this.selectedOptions.length) {
            form.response_type_options = JSON.stringify(this.selectedOptions);
          } else {
            form.response_type_options = '[]';
          }
        }

        if (this.responseTypeDoc && this.responseTypeDoc.value && this.responseTypeDoc.value === 'Yes/No') {
          let array = [
            {title: 'Yes', value: this.yesValueDoc},
            {title: 'No', value: this.noValueDoc},
          ]
          form.response_type_options_doc = JSON.stringify(array);
        }

        if (this.responseTypeDoc && this.responseTypeDoc.value && this.responseTypeDoc.value === 'Dropdown') {
          if (this.selectedOptionsDoc && this.selectedOptionsDoc.length) {
            form.response_type_options_doc = JSON.stringify(this.selectedOptionsDoc);
          } else {
            form.response_type_options_doc = '[]';
          }
        }


        if (this.selectedFrameworkControls && this.selectedFrameworkControls.length) {
          form.framework_controls = [];
          for (let i = 0; i < this.selectedFrameworkControls.length; i++) {
            form.framework_controls.push(this.selectedFrameworkControls[i].id);
          }
        }
        form.linked_controls = [];
        if (this.selectedLinkedControls && this.selectedLinkedControls.length) {

          for (let i = 0; i < this.selectedLinkedControls.length; i++) {
            form.linked_controls.push(this.selectedLinkedControls[i].id);
          }
        }

        if (this.selectedQuestionDependency && this.selectedQuestionDependency.id) {
          form.dependency_question_id = this.selectedQuestionDependency.id;
          form.dependency_question_answer = [];
          for (let i = 0; i < this.selectedAnswers.length; i++) {
            form.dependency_question_answer.push(this.selectedAnswers[i].title);
          }
        } else {
          form.dependency_question_id = '';
        }

        if (((this.responseType && this.responseType.value) || (this.addResponse && this.addResponse.value === 'No')) && this.form.description.length && this.addDescription && this.addDescription.value && this.addResponse && this.addResponse.value && this.addControlDescription && this.addControlDescription.value && this.addNotes && this.addNotes.value && this.addPerformedText && this.addPerformedText.value && this.addAttachments && this.addAttachments.value && ((this.addResponse && this.addResponse.value === 'No') || (this.responseType && (this.responseType.value === 'Datepicker' || this.responseType.value === 'Yes/No')) || (this.responseType && this.responseType.value === 'Dropdown' && this.selectedOptions && this.selectedOptions.length))) {
          piincHttp.put('questions/' + this.selectedQuestion.slug, form).then(function() {
            self.$toastr('success', self.$t('maintenance.questions.update.success'));
            self.hideEditQModal();
            if(self.assessment.type === 'control'){
              self.loadQuestions();
            }else{
              self.loadRiskQuestions();
            }
            self.$emit('updated');
            self.buttonDisabled = false;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          if (!this.responseType || (this.responseType && !this.responseType.value)) {
            this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message');
          }
          if (!this.addDescription || (this.addDescription && !this.addDescription.value)) {
            this.error += this.$t('maintenance.questions.create.add_description_error_message');
          }
          if (!this.addResponse || (this.addResponse && !this.addResponse.value)) {
            this.error += this.$t('maintenance.questions.create.add_response_error_message');
          }
          if (!this.addAttachments || (this.addAttachments && !this.addAttachments.value)) {
            this.error += this.$t('maintenance.questions.create.add_attachments_error_message');
          }
          if ((this.responseType && this.responseType.value === 'Select') && this.selectedOptions && !this.selectedOptions.length) {
            this.error += this.$t('maintenance.questions.create.selected_options_error_message');
          }
        }
      },
      loadQuestion() {
        let self = this;

        piincHttp.get('questions/' + this.selectedQuestion.slug).then(function(response) {
          self.selectedQuestion.media = response.data.media;
          self.selectedQuestion.links = response.data.links;
        }, function() {});
      },
      loadRiskQuestions() {
        let self = this;

        piincHttp.get('questions', { params:
            {
              page: 1,
              per_page: 1,
              assessment: this.assessment.id,
              client: this.getClient.slug
            }
        }).then(function(response) {
          let total = response.data.total_count

          piincHttp.get('questions', { params:
              {
                page: 1,
                per_page: total,
                assessment: self.assessment.id,
                client: self.getClient.slug
              }
          }).then(function(response) {
            self.loading = false;
            self.tableRiskItems = response.data.items;

            // Set number of total items
            self.totalRows = response.data.total_count;
          }, function() {});
        }, function() {});
      },
      loadQuestions() {
        let self = this;

        piincHttp.get('assessment-control-objectives', { params:
          {
            page: 1,
            per_page: 1,
            assessment: this.assessment.id,
            client: this.getClient.slug
          }
        }).then(function(response) {
          let total = response.data.total_count;

          piincHttp.get('assessment-control-objectives', { params:
            {
              page: 1,
              per_page: total,
              assessment: self.assessment.id,
              client: self.getClient.slug
            }
          }).then(function(response) {

            self.tableItems = []
            // Set number of total items
            self.totalRows = response.data.total_count;

            if (!response.data.items.length) {
              self.loading = false;
            }

            _.forEach(response.data.items, function(item, key) {

              piincHttp.get('questions', { params:
                {
                  client: self.getClient.slug,
                  control_objective: item.id,
                  per_page: 100,
                  assessment: self.assessment.id
                }
              }).then(function(responseQuestions) {
                item.questionItems = responseQuestions.data.items;
                self.tableItems.splice(key, 0, item)
                self.tableItems = _.sortBy(self.tableItems, ['order']);
                self.loading = false;
              }, function() {});
            });

          }, function() {});
        }, function() {});
      },
      loadContent() {
        let self = this;
        piincHttp.get('assessments/' + this.$route.params.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.assessment = response.data;
        }, function() {});
      },
      loadCO() {
        let self = this;
        piincHttp.get('/assessment-control-objectives', { params:
          {
            client: this.getClient.slug,
            assessment: this.assessment.id,
            per_page: 100,
            // keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.controlObjectives = response.data.items;

          if (self.controlObjectives && !self.controlObjectives.length && !query) {
            self.controlObjectives.push({name: self.$t('system.no_results'), $isDisabled: true});
          }
        }, function() {});
      },
    },
    created () {
      this.assessment = this.object;
      if (this.getClient && this.getClient.slug) {

      }
      // Table items
      if(this.assessment.type === 'control'){
        this.loadQuestions();
      }else{
        this.loadRiskQuestions();
      }


      this.loadGuides('assessment_template_questions');

    }
  }
</script>
